import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import * as i1 from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var FeeAmountType = /*#__PURE__*/function (FeeAmountType) {
  FeeAmountType[FeeAmountType["FEE_AMOUNT_TYPE_INVALID"] = 0] = "FEE_AMOUNT_TYPE_INVALID";
  FeeAmountType[FeeAmountType["FEE_AMOUNT_TYPE_FIXED"] = 1] = "FEE_AMOUNT_TYPE_FIXED";
  FeeAmountType[FeeAmountType["FEE_AMOUNT_TYPE_PERCENTAGE"] = 2] = "FEE_AMOUNT_TYPE_PERCENTAGE";
  return FeeAmountType;
}(FeeAmountType || {});
var FeeType = /*#__PURE__*/function (FeeType) {
  FeeType[FeeType["FEE_TYPE_INVALID"] = 0] = "FEE_TYPE_INVALID";
  FeeType[FeeType["FEE_TYPE_MANAGEMENT"] = 1] = "FEE_TYPE_MANAGEMENT";
  return FeeType;
}(FeeType || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var AppType = /*#__PURE__*/function (AppType) {
  AppType[AppType["APP_TYPE_APP"] = 0] = "APP_TYPE_APP";
  AppType[AppType["APP_TYPE_ADDON"] = 1] = "APP_TYPE_ADDON";
  AppType[AppType["APP_TYPE_UNSPECIFIED"] = 2] = "APP_TYPE_UNSPECIFIED";
  return AppType;
}(AppType || {});
var ApprovalProcess = /*#__PURE__*/function (ApprovalProcess) {
  ApprovalProcess[ApprovalProcess["APPROVAL_PROCESS_INVALID"] = 0] = "APPROVAL_PROCESS_INVALID";
  ApprovalProcess[ApprovalProcess["APPROVAL_PROCESS_VENDASTA"] = 1] = "APPROVAL_PROCESS_VENDASTA";
  ApprovalProcess[ApprovalProcess["APPROVAL_PROCESS_VENDOR"] = 2] = "APPROVAL_PROCESS_VENDOR";
  return ApprovalProcess;
}(ApprovalProcess || {});
var BillingProcess = /*#__PURE__*/function (BillingProcess) {
  BillingProcess[BillingProcess["BILLING_PROCESS_INVALID"] = 0] = "BILLING_PROCESS_INVALID";
  BillingProcess[BillingProcess["BILLING_PROCESS_NO_BILLING"] = 1] = "BILLING_PROCESS_NO_BILLING";
  BillingProcess[BillingProcess["BILLING_PROCESS_VENDASTA_BILLING"] = 2] = "BILLING_PROCESS_VENDASTA_BILLING";
  return BillingProcess;
}(BillingProcess || {});
var DeliveryMethod = /*#__PURE__*/function (DeliveryMethod) {
  DeliveryMethod[DeliveryMethod["DELIVERY_METHOD_INVALID"] = 0] = "DELIVERY_METHOD_INVALID";
  DeliveryMethod[DeliveryMethod["DELIVERY_METHOD_PRODUCT"] = 1] = "DELIVERY_METHOD_PRODUCT";
  DeliveryMethod[DeliveryMethod["DELIVERY_METHOD_SERVICE"] = 2] = "DELIVERY_METHOD_SERVICE";
  return DeliveryMethod;
}(DeliveryMethod || {});
var DistributionSetting = /*#__PURE__*/function (DistributionSetting) {
  DistributionSetting[DistributionSetting["DISTRIBUTION_SETTING_INVALID"] = 0] = "DISTRIBUTION_SETTING_INVALID";
  DistributionSetting[DistributionSetting["DISTRIBUTION_SETTING_ALL"] = 1] = "DISTRIBUTION_SETTING_ALL";
  DistributionSetting[DistributionSetting["DISTRIBUTION_SETTING_SELF"] = 2] = "DISTRIBUTION_SETTING_SELF";
  return DistributionSetting;
}(DistributionSetting || {});
var EndOfTrialActions = /*#__PURE__*/function (EndOfTrialActions) {
  EndOfTrialActions[EndOfTrialActions["DO_NOTHING"] = 0] = "DO_NOTHING";
  return EndOfTrialActions;
}(EndOfTrialActions || {});
var MarketplaceAppLmiLmiCategories = /*#__PURE__*/function (MarketplaceAppLmiLmiCategories) {
  MarketplaceAppLmiLmiCategories[MarketplaceAppLmiLmiCategories["NOT_SET"] = 0] = "NOT_SET";
  MarketplaceAppLmiLmiCategories[MarketplaceAppLmiLmiCategories["WEBSITE"] = 1] = "WEBSITE";
  MarketplaceAppLmiLmiCategories[MarketplaceAppLmiLmiCategories["CONTENT_AND_EXPERIENCE"] = 2] = "CONTENT_AND_EXPERIENCE";
  MarketplaceAppLmiLmiCategories[MarketplaceAppLmiLmiCategories["LISTINGS"] = 3] = "LISTINGS";
  MarketplaceAppLmiLmiCategories[MarketplaceAppLmiLmiCategories["REPUTATION"] = 4] = "REPUTATION";
  MarketplaceAppLmiLmiCategories[MarketplaceAppLmiLmiCategories["SEO"] = 5] = "SEO";
  MarketplaceAppLmiLmiCategories[MarketplaceAppLmiLmiCategories["SOCIAL"] = 6] = "SOCIAL";
  MarketplaceAppLmiLmiCategories[MarketplaceAppLmiLmiCategories["ADVERTISING"] = 7] = "ADVERTISING";
  return MarketplaceAppLmiLmiCategories;
}(MarketplaceAppLmiLmiCategories || {});
var MarketplaceAppProductProductCategories = /*#__PURE__*/function (MarketplaceAppProductProductCategories) {
  MarketplaceAppProductProductCategories[MarketplaceAppProductProductCategories["NOT_SET"] = 0] = "NOT_SET";
  MarketplaceAppProductProductCategories[MarketplaceAppProductProductCategories["DIGITAL"] = 1] = "DIGITAL";
  MarketplaceAppProductProductCategories[MarketplaceAppProductProductCategories["WEBSITE"] = 2] = "WEBSITE";
  MarketplaceAppProductProductCategories[MarketplaceAppProductProductCategories["PRINT"] = 3] = "PRINT";
  MarketplaceAppProductProductCategories[MarketplaceAppProductProductCategories["YELLOW_PAGES"] = 4] = "YELLOW_PAGES";
  MarketplaceAppProductProductCategories[MarketplaceAppProductProductCategories["RADIO"] = 5] = "RADIO";
  MarketplaceAppProductProductCategories[MarketplaceAppProductProductCategories["TELEVISION"] = 6] = "TELEVISION";
  MarketplaceAppProductProductCategories[MarketplaceAppProductProductCategories["SEM"] = 7] = "SEM";
  MarketplaceAppProductProductCategories[MarketplaceAppProductProductCategories["SEO"] = 8] = "SEO";
  MarketplaceAppProductProductCategories[MarketplaceAppProductProductCategories["COMBINATION"] = 9] = "COMBINATION";
  MarketplaceAppProductProductCategories[MarketplaceAppProductProductCategories["SOCIAL"] = 10] = "SOCIAL";
  MarketplaceAppProductProductCategories[MarketplaceAppProductProductCategories["VENDASTA_APP"] = 11] = "VENDASTA_APP";
  MarketplaceAppProductProductCategories[MarketplaceAppProductProductCategories["OTHER"] = 12] = "OTHER";
  MarketplaceAppProductProductCategories[MarketplaceAppProductProductCategories["VENDOR_APP"] = 13] = "VENDOR_APP";
  return MarketplaceAppProductProductCategories;
}(MarketplaceAppProductProductCategories || {});
var ReleaseType = /*#__PURE__*/function (ReleaseType) {
  ReleaseType[ReleaseType["RELEASE_TYPE_PUBLISH"] = 0] = "RELEASE_TYPE_PUBLISH";
  ReleaseType[ReleaseType["RELEASE_TYPE_DRAFT"] = 1] = "RELEASE_TYPE_DRAFT";
  return ReleaseType;
}(ReleaseType || {});
var State = /*#__PURE__*/function (State) {
  State[State["STATE_INVALID"] = 0] = "STATE_INVALID";
  State[State["STATE_DRAFT"] = 1] = "STATE_DRAFT";
  State[State["STATE_PUBLISHED"] = 2] = "STATE_PUBLISHED";
  return State;
}(State || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var StateFilterOptions = /*#__PURE__*/function (StateFilterOptions) {
  StateFilterOptions[StateFilterOptions["STATE_FILTER_OPTIONS_PUBLISHED"] = 0] = "STATE_FILTER_OPTIONS_PUBLISHED";
  StateFilterOptions[StateFilterOptions["STATE_FILTER_OPTIONS_STATE_DRAFT"] = 1] = "STATE_FILTER_OPTIONS_STATE_DRAFT";
  StateFilterOptions[StateFilterOptions["STATE_FILTER_OPTIONS_STATE_ALL"] = 2] = "STATE_FILTER_OPTIONS_STATE_ALL";
  return StateFilterOptions;
}(StateFilterOptions || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var EditionBillingFrequency = /*#__PURE__*/function (EditionBillingFrequency) {
  EditionBillingFrequency[EditionBillingFrequency["EDITION_BILLING_FREQUENCY_INVALID"] = 0] = "EDITION_BILLING_FREQUENCY_INVALID";
  EditionBillingFrequency[EditionBillingFrequency["EDITION_BILLING_FREQUENCY_MONTHLY"] = 1] = "EDITION_BILLING_FREQUENCY_MONTHLY";
  EditionBillingFrequency[EditionBillingFrequency["EDITION_BILLING_FREQUENCY_YEARLY"] = 2] = "EDITION_BILLING_FREQUENCY_YEARLY";
  EditionBillingFrequency[EditionBillingFrequency["EDITION_BILLING_FREQUENCY_ONETIME"] = 3] = "EDITION_BILLING_FREQUENCY_ONETIME";
  return EditionBillingFrequency;
}(EditionBillingFrequency || {});
var Release = /*#__PURE__*/function (Release) {
  Release[Release["RELEASE_PUBLISH"] = 0] = "RELEASE_PUBLISH";
  Release[Release["RELEASE_DRAFT"] = 1] = "RELEASE_DRAFT";
  return Release;
}(Release || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums Index.
// *********************************

function enumStringToValue$c(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Fee {
  static fromProto(proto) {
    let m = new Fee();
    m = Object.assign(m, proto);
    if (proto.amountType) {
      m.amountType = enumStringToValue$c(FeeAmountType, proto.amountType);
    }
    if (proto.feeType) {
      m.feeType = enumStringToValue$c(FeeType, proto.feeType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.amount !== 'undefined') {
      toReturn['amount'] = this.amount;
    }
    if (typeof this.amountType !== 'undefined') {
      toReturn['amountType'] = this.amountType;
    }
    if (typeof this.feeType !== 'undefined') {
      toReturn['feeType'] = this.feeType;
    }
    return toReturn;
  }
}
function enumStringToValue$b(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Commitment {
  static fromProto(proto) {
    let m = new Commitment();
    m = Object.assign(m, proto);
    if (proto.initial) {
      m.initial = parseInt(proto.initial, 10);
    }
    if (proto.recurring) {
      m.recurring = parseInt(proto.recurring, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.initial !== 'undefined') {
      toReturn['initial'] = this.initial;
    }
    if (typeof this.recurring !== 'undefined') {
      toReturn['recurring'] = this.recurring;
    }
    return toReturn;
  }
}
function enumStringToValue$a(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class IncludedCommonFormFields {
  static fromProto(proto) {
    let m = new IncludedCommonFormFields();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessName !== 'undefined') {
      toReturn['businessName'] = this.businessName;
    }
    if (typeof this.businessAddress !== 'undefined') {
      toReturn['businessAddress'] = this.businessAddress;
    }
    if (typeof this.businessPhoneNumber !== 'undefined') {
      toReturn['businessPhoneNumber'] = this.businessPhoneNumber;
    }
    if (typeof this.businessAccountGroupId !== 'undefined') {
      toReturn['businessAccountGroupId'] = this.businessAccountGroupId;
    }
    if (typeof this.salespersonName !== 'undefined') {
      toReturn['salespersonName'] = this.salespersonName;
    }
    if (typeof this.salespersonPhoneNumber !== 'undefined') {
      toReturn['salespersonPhoneNumber'] = this.salespersonPhoneNumber;
    }
    if (typeof this.salespersonEmail !== 'undefined') {
      toReturn['salespersonEmail'] = this.salespersonEmail;
    }
    if (typeof this.contactName !== 'undefined') {
      toReturn['contactName'] = this.contactName;
    }
    if (typeof this.contactPhoneNumber !== 'undefined') {
      toReturn['contactPhoneNumber'] = this.contactPhoneNumber;
    }
    if (typeof this.contactEmail !== 'undefined') {
      toReturn['contactEmail'] = this.contactEmail;
    }
    if (typeof this.businessWebsite !== 'undefined') {
      toReturn['businessWebsite'] = this.businessWebsite;
    }
    return toReturn;
  }
}
class OrderFormFieldOption {
  static fromProto(proto) {
    let m = new OrderFormFieldOption();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.label !== 'undefined') {
      toReturn['label'] = this.label;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}
class OrderForm {
  static fromProto(proto) {
    let m = new OrderForm();
    m = Object.assign(m, proto);
    if (proto.orderForm) {
      m.orderForm = proto.orderForm.map(OrderFormField.fromProto);
    }
    if (proto.commonForm) {
      m.commonForm = IncludedCommonFormFields.fromProto(proto.commonForm);
    }
    if (proto.commonFormRequiredFields) {
      m.commonFormRequiredFields = IncludedCommonFormFields.fromProto(proto.commonFormRequiredFields);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.orderForm !== 'undefined' && this.orderForm !== null) {
      toReturn['orderForm'] = 'toApiJson' in this.orderForm ? this.orderForm.toApiJson() : this.orderForm;
    }
    if (typeof this.commonForm !== 'undefined' && this.commonForm !== null) {
      toReturn['commonForm'] = 'toApiJson' in this.commonForm ? this.commonForm.toApiJson() : this.commonForm;
    }
    if (typeof this.activationMessage !== 'undefined') {
      toReturn['activationMessage'] = this.activationMessage;
    }
    if (typeof this.separateOrderForms !== 'undefined') {
      toReturn['separateOrderForms'] = this.separateOrderForms;
    }
    if (typeof this.commonFormRequiredFields !== 'undefined' && this.commonFormRequiredFields !== null) {
      toReturn['commonFormRequiredFields'] = 'toApiJson' in this.commonFormRequiredFields ? this.commonFormRequiredFields.toApiJson() : this.commonFormRequiredFields;
    }
    if (typeof this.usesPostBillingOrderForm !== 'undefined') {
      toReturn['usesPostBillingOrderForm'] = this.usesPostBillingOrderForm;
    }
    if (typeof this.footerText !== 'undefined') {
      toReturn['footerText'] = this.footerText;
    }
    return toReturn;
  }
}
class OrderFormField {
  static fromProto(proto) {
    let m = new OrderFormField();
    m = Object.assign(m, proto);
    if (proto.maxChoices) {
      m.maxChoices = parseInt(proto.maxChoices, 10);
    }
    if (proto.optionsWithLabels) {
      m.optionsWithLabels = proto.optionsWithLabels.map(OrderFormFieldOption.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.label !== 'undefined') {
      toReturn['label'] = this.label;
    }
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    if (typeof this.options !== 'undefined') {
      toReturn['options'] = this.options;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.required !== 'undefined') {
      toReturn['required'] = this.required;
    }
    if (typeof this.uploadUrl !== 'undefined') {
      toReturn['uploadUrl'] = this.uploadUrl;
    }
    if (typeof this.prefix !== 'undefined') {
      toReturn['prefix'] = this.prefix;
    }
    if (typeof this.suffix !== 'undefined') {
      toReturn['suffix'] = this.suffix;
    }
    if (typeof this.regexValidator !== 'undefined') {
      toReturn['regexValidator'] = this.regexValidator;
    }
    if (typeof this.regexErrorMessage !== 'undefined') {
      toReturn['regexErrorMessage'] = this.regexErrorMessage;
    }
    if (typeof this.useWebhookValidator !== 'undefined') {
      toReturn['useWebhookValidator'] = this.useWebhookValidator;
    }
    if (typeof this.allowMultiples !== 'undefined') {
      toReturn['allowMultiples'] = this.allowMultiples;
    }
    if (typeof this.allowDuplicates !== 'undefined') {
      toReturn['allowDuplicates'] = this.allowDuplicates;
    }
    if (typeof this.maxChoices !== 'undefined') {
      toReturn['maxChoices'] = this.maxChoices;
    }
    if (typeof this.forOfficeUseOnly !== 'undefined') {
      toReturn['forOfficeUseOnly'] = this.forOfficeUseOnly;
    }
    if (typeof this.optionsWithLabels !== 'undefined' && this.optionsWithLabels !== null) {
      toReturn['optionsWithLabels'] = 'toApiJson' in this.optionsWithLabels ? this.optionsWithLabels.toApiJson() : this.optionsWithLabels;
    }
    if (typeof this.officeEditableOnly !== 'undefined') {
      toReturn['officeEditableOnly'] = this.officeEditableOnly;
    }
    return toReturn;
  }
}
function enumStringToValue$9(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class AppRequirement {
  static fromProto(proto) {
    let m = new AppRequirement();
    m = Object.assign(m, proto);
    if (proto.rules) {
      m.rules = proto.rules.map(Rule.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.rules !== 'undefined' && this.rules !== null) {
      toReturn['rules'] = 'toApiJson' in this.rules ? this.rules.toApiJson() : this.rules;
    }
    if (typeof this.childrenAppIds !== 'undefined') {
      toReturn['childrenAppIds'] = this.childrenAppIds;
    }
    return toReturn;
  }
}
class EditionIdentifier {
  static fromProto(proto) {
    let m = new EditionIdentifier();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.editionId !== 'undefined') {
      toReturn['editionId'] = this.editionId;
    }
    return toReturn;
  }
}
class PermissionLists {
  static fromProto(proto) {
    let m = new PermissionLists();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.whitelist !== 'undefined') {
      toReturn['whitelist'] = this.whitelist;
    }
    if (typeof this.blacklist !== 'undefined') {
      toReturn['blacklist'] = this.blacklist;
    }
    return toReturn;
  }
}
class RequiredBusinessData {
  static fromProto(proto) {
    let m = new RequiredBusinessData();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.hours !== 'undefined') {
      toReturn['hours'] = this.hours;
    }
    if (typeof this.descriptionLong !== 'undefined') {
      toReturn['descriptionLong'] = this.descriptionLong;
    }
    if (typeof this.descriptionShort !== 'undefined') {
      toReturn['descriptionShort'] = this.descriptionShort;
    }
    if (typeof this.services !== 'undefined') {
      toReturn['services'] = this.services;
    }
    if (typeof this.brands !== 'undefined') {
      toReturn['brands'] = this.brands;
    }
    return toReturn;
  }
}
class RequiredFeatures {
  static fromProto(proto) {
    let m = new RequiredFeatures();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.whitelist !== 'undefined') {
      toReturn['whitelist'] = this.whitelist;
    }
    return toReturn;
  }
}
class Restrictions {
  static fromProto(proto) {
    let m = new Restrictions();
    m = Object.assign(m, proto);
    if (proto.country) {
      m.country = PermissionLists.fromProto(proto.country);
    }
    if (proto.appRequirement) {
      m.appRequirement = AppRequirement.fromProto(proto.appRequirement);
    }
    if (proto.requiredFeatures) {
      m.requiredFeatures = RequiredFeatures.fromProto(proto.requiredFeatures);
    }
    if (proto.requiredBusinessData) {
      m.requiredBusinessData = RequiredBusinessData.fromProto(proto.requiredBusinessData);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.country !== 'undefined' && this.country !== null) {
      toReturn['country'] = 'toApiJson' in this.country ? this.country.toApiJson() : this.country;
    }
    if (typeof this.appRequirement !== 'undefined' && this.appRequirement !== null) {
      toReturn['appRequirement'] = 'toApiJson' in this.appRequirement ? this.appRequirement.toApiJson() : this.appRequirement;
    }
    if (typeof this.requiredFeatures !== 'undefined' && this.requiredFeatures !== null) {
      toReturn['requiredFeatures'] = 'toApiJson' in this.requiredFeatures ? this.requiredFeatures.toApiJson() : this.requiredFeatures;
    }
    if (typeof this.requiredBusinessData !== 'undefined' && this.requiredBusinessData !== null) {
      toReturn['requiredBusinessData'] = 'toApiJson' in this.requiredBusinessData ? this.requiredBusinessData.toApiJson() : this.requiredBusinessData;
    }
    return toReturn;
  }
}
class Rule {
  static fromProto(proto) {
    let m = new Rule();
    m = Object.assign(m, proto);
    if (proto.requiredEditions) {
      m.requiredEditions = proto.requiredEditions.map(EditionIdentifier.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appIds !== 'undefined') {
      toReturn['appIds'] = this.appIds;
    }
    if (typeof this.requiredEditions !== 'undefined' && this.requiredEditions !== null) {
      toReturn['requiredEditions'] = 'toApiJson' in this.requiredEditions ? this.requiredEditions.toApiJson() : this.requiredEditions;
    }
    return toReturn;
  }
}
function enumStringToValue$8(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Contact {
  static fromProto(proto) {
    let m = new Contact();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    return toReturn;
  }
}
class Cost {
  static fromProto(proto) {
    let m = new Cost();
    m = Object.assign(m, proto);
    if (proto.price) {
      m.price = parseInt(proto.price, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.billingFrequency !== 'undefined') {
      toReturn['billingFrequency'] = this.billingFrequency;
    }
    if (typeof this.currency !== 'undefined') {
      toReturn['currency'] = this.currency;
    }
    if (typeof this.price !== 'undefined') {
      toReturn['price'] = this.price;
    }
    return toReturn;
  }
}
class FrequentlyAskedQuestions {
  static fromProto(proto) {
    let m = new FrequentlyAskedQuestions();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.question !== 'undefined') {
      toReturn['question'] = this.question;
    }
    if (typeof this.answer !== 'undefined') {
      toReturn['answer'] = this.answer;
    }
    return toReturn;
  }
}
class IdentifiedPublicKey {
  static fromProto(proto) {
    let m = new IdentifiedPublicKey();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.publicKeyId !== 'undefined') {
      toReturn['publicKeyId'] = this.publicKeyId;
    }
    if (typeof this.publicKey !== 'undefined') {
      toReturn['publicKey'] = this.publicKey;
    }
    return toReturn;
  }
}
class Integration {
  static fromProto(proto) {
    let m = new Integration();
    m = Object.assign(m, proto);
    if (proto.identifiedPublicKeys) {
      m.identifiedPublicKeys = proto.identifiedPublicKeys.map(IdentifiedPublicKey.fromProto);
    }
    if (proto.partnerContactRecipients) {
      m.partnerContactRecipients = proto.partnerContactRecipients.map(Contact.fromProto);
    }
    if (proto.appApprovalProcess) {
      m.appApprovalProcess = enumStringToValue$8(ApprovalProcess, proto.appApprovalProcess);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.publicKey !== 'undefined') {
      toReturn['publicKey'] = this.publicKey;
    }
    if (typeof this.identifiedPublicKeys !== 'undefined' && this.identifiedPublicKeys !== null) {
      toReturn['identifiedPublicKeys'] = 'toApiJson' in this.identifiedPublicKeys ? this.identifiedPublicKeys.toApiJson() : this.identifiedPublicKeys;
    }
    if (typeof this.contactEmail !== 'undefined') {
      toReturn['contactEmail'] = this.contactEmail;
    }
    if (typeof this.approved !== 'undefined') {
      toReturn['approved'] = this.approved;
    }
    if (typeof this.vendor !== 'undefined') {
      toReturn['vendor'] = this.vendor;
    }
    if (typeof this.userIds !== 'undefined') {
      toReturn['userIds'] = this.userIds;
    }
    if (typeof this.purchaseWebhookUrl !== 'undefined') {
      toReturn['purchaseWebhookUrl'] = this.purchaseWebhookUrl;
    }
    if (typeof this.addonPurchaseWebhookUrl !== 'undefined') {
      toReturn['addonPurchaseWebhookUrl'] = this.addonPurchaseWebhookUrl;
    }
    if (typeof this.userModWebhookUrl !== 'undefined') {
      toReturn['userModWebhookUrl'] = this.userModWebhookUrl;
    }
    if (typeof this.salestoolWebhookUrl !== 'undefined') {
      toReturn['salestoolWebhookUrl'] = this.salestoolWebhookUrl;
    }
    if (typeof this.accountModWebhookUrl !== 'undefined') {
      toReturn['accountModWebhookUrl'] = this.accountModWebhookUrl;
    }
    if (typeof this.logoutWebhookUrl !== 'undefined') {
      toReturn['logoutWebhookUrl'] = this.logoutWebhookUrl;
    }
    if (typeof this.fulfillmentEmail !== 'undefined') {
      toReturn['fulfillmentEmail'] = this.fulfillmentEmail;
    }
    if (typeof this.entryUrl !== 'undefined') {
      toReturn['entryUrl'] = this.entryUrl;
    }
    if (typeof this.sessionUrl !== 'undefined') {
      toReturn['sessionUrl'] = this.sessionUrl;
    }
    if (typeof this.settingsUrl !== 'undefined') {
      toReturn['settingsUrl'] = this.settingsUrl;
    }
    if (typeof this.reserveIdUrl !== 'undefined') {
      toReturn['reserveIdUrl'] = this.reserveIdUrl;
    }
    if (typeof this.contactWebhookUrl !== 'undefined') {
      toReturn['contactWebhookUrl'] = this.contactWebhookUrl;
    }
    if (typeof this.activationRequiresApproval !== 'undefined') {
      toReturn['activationRequiresApproval'] = this.activationRequiresApproval;
    }
    if (typeof this.partnerSettingsWebhookUrl !== 'undefined') {
      toReturn['partnerSettingsWebhookUrl'] = this.partnerSettingsWebhookUrl;
    }
    if (typeof this.partnerContactRecipients !== 'undefined' && this.partnerContactRecipients !== null) {
      toReturn['partnerContactRecipients'] = 'toApiJson' in this.partnerContactRecipients ? this.partnerContactRecipients.toApiJson() : this.partnerContactRecipients;
    }
    if (typeof this.appApprovalProcess !== 'undefined') {
      toReturn['appApprovalProcess'] = this.appApprovalProcess;
    }
    if (typeof this.orderFormValidatorWebhookUrl !== 'undefined') {
      toReturn['orderFormValidatorWebhookUrl'] = this.orderFormValidatorWebhookUrl;
    }
    if (typeof this.allowWhiteLabeling !== 'undefined') {
      toReturn['allowWhiteLabeling'] = this.allowWhiteLabeling;
    }
    if (typeof this.customerWebhookUrl !== 'undefined') {
      toReturn['customerWebhookUrl'] = this.customerWebhookUrl;
    }
    if (typeof this.sendCancelationNotifications !== 'undefined') {
      toReturn['sendCancelationNotifications'] = this.sendCancelationNotifications;
    }
    if (typeof this.cancellationWehookUrl !== 'undefined') {
      toReturn['cancellationWehookUrl'] = this.cancellationWehookUrl;
    }
    if (typeof this.serviceChangeWebhookUrl !== 'undefined') {
      toReturn['serviceChangeWebhookUrl'] = this.serviceChangeWebhookUrl;
    }
    if (typeof this.appLevelHasAdminDashboard !== 'undefined') {
      toReturn['appLevelHasAdminDashboard'] = this.appLevelHasAdminDashboard;
    }
    return toReturn;
  }
}
class MarketplaceAppLmi {
  static fromProto(proto) {
    let m = new MarketplaceAppLmi();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    return toReturn;
  }
}
class MarketingInformation {
  static fromProto(proto) {
    let m = new MarketingInformation();
    m = Object.assign(m, proto);
    if (proto.faqs) {
      m.faqs = proto.faqs.map(FrequentlyAskedQuestions.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.keySellingPoints !== 'undefined') {
      toReturn['keySellingPoints'] = this.keySellingPoints;
    }
    if (typeof this.faqs !== 'undefined' && this.faqs !== null) {
      toReturn['faqs'] = 'toApiJson' in this.faqs ? this.faqs.toApiJson() : this.faqs;
    }
    if (typeof this.files !== 'undefined') {
      toReturn['files'] = this.files;
    }
    if (typeof this.needHelp !== 'undefined') {
      toReturn['needHelp'] = this.needHelp;
    }
    if (typeof this.videos !== 'undefined') {
      toReturn['videos'] = this.videos;
    }
    return toReturn;
  }
}
class MarketplaceApp {
  static fromProto(proto) {
    let m = new MarketplaceApp();
    m = Object.assign(m, proto);
    if (proto.version) {
      m.version = parseInt(proto.version, 10);
    }
    if (proto.price) {
      m.price = parseInt(proto.price, 10);
    }
    if (proto.productCategory) {
      m.productCategory = enumStringToValue$8(MarketplaceAppProductProductCategories, proto.productCategory);
    }
    if (proto.lmiCategories) {
      m.lmiCategories = proto.lmiCategories.map(v => enumStringToValue$8(MarketplaceAppLmiLmiCategories, v));
    }
    if (proto.integration) {
      m.integration = Integration.fromProto(proto.integration);
    }
    if (proto.orderForm) {
      m.orderForm = OrderForm.fromProto(proto.orderForm);
    }
    if (proto.resellerMarketing) {
      m.resellerMarketing = MarketingInformation.fromProto(proto.resellerMarketing);
    }
    if (proto.endUserMarketing) {
      m.endUserMarketing = MarketingInformation.fromProto(proto.endUserMarketing);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.restrictions) {
      m.restrictions = Restrictions.fromProto(proto.restrictions);
    }
    if (proto.suggestedRetailPrice) {
      m.suggestedRetailPrice = parseInt(proto.suggestedRetailPrice, 10);
    }
    if (proto.commitment) {
      m.commitment = Commitment.fromProto(proto.commitment);
    }
    if (proto.trialConfiguration) {
      m.trialConfiguration = TrialConfiguration.fromProto(proto.trialConfiguration);
    }
    if (proto.state) {
      m.state = enumStringToValue$8(State, proto.state);
    }
    if (proto.type) {
      m.type = enumStringToValue$8(AppType, proto.type);
    }
    if (proto.cost) {
      m.cost = Cost.fromProto(proto.cost);
    }
    if (proto.billingProcess) {
      m.billingProcess = enumStringToValue$8(BillingProcess, proto.billingProcess);
    }
    if (proto.setupFee) {
      m.setupFee = parseInt(proto.setupFee, 10);
    }
    if (proto.suspended) {
      m.suspended = new Date(proto.suspended);
    }
    if (proto.deliveryMethod) {
      m.deliveryMethod = enumStringToValue$8(DeliveryMethod, proto.deliveryMethod);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.icon !== 'undefined') {
      toReturn['icon'] = this.icon;
    }
    if (typeof this.allowWhitelabel !== 'undefined') {
      toReturn['allowWhitelabel'] = this.allowWhitelabel;
    }
    if (typeof this.inDevelopment !== 'undefined') {
      toReturn['inDevelopment'] = this.inDevelopment;
    }
    if (typeof this.trialSupport !== 'undefined') {
      toReturn['trialSupport'] = this.trialSupport;
    }
    if (typeof this.usesOrderForm !== 'undefined') {
      toReturn['usesOrderForm'] = this.usesOrderForm;
    }
    if (typeof this.tagline !== 'undefined') {
      toReturn['tagline'] = this.tagline;
    }
    if (typeof this.signInUrl !== 'undefined') {
      toReturn['signInUrl'] = this.signInUrl;
    }
    if (typeof this.currency !== 'undefined') {
      toReturn['currency'] = this.currency;
    }
    if (typeof this.price !== 'undefined') {
      toReturn['price'] = this.price;
    }
    if (typeof this.billingFrequency !== 'undefined') {
      toReturn['billingFrequency'] = this.billingFrequency;
    }
    if (typeof this.serviceModel !== 'undefined') {
      toReturn['serviceModel'] = this.serviceModel;
    }
    if (typeof this.screenshot !== 'undefined') {
      toReturn['screenshot'] = this.screenshot;
    }
    if (typeof this.websiteUrl !== 'undefined') {
      toReturn['websiteUrl'] = this.websiteUrl;
    }
    if (typeof this.headerImage !== 'undefined') {
      toReturn['headerImage'] = this.headerImage;
    }
    if (typeof this.productCategory !== 'undefined') {
      toReturn['productCategory'] = this.productCategory;
    }
    if (typeof this.lmiCategories !== 'undefined') {
      toReturn['lmiCategories'] = this.lmiCategories;
    }
    if (typeof this.integration !== 'undefined' && this.integration !== null) {
      toReturn['integration'] = 'toApiJson' in this.integration ? this.integration.toApiJson() : this.integration;
    }
    if (typeof this.orderForm !== 'undefined' && this.orderForm !== null) {
      toReturn['orderForm'] = 'toApiJson' in this.orderForm ? this.orderForm.toApiJson() : this.orderForm;
    }
    if (typeof this.resellerMarketing !== 'undefined' && this.resellerMarketing !== null) {
      toReturn['resellerMarketing'] = 'toApiJson' in this.resellerMarketing ? this.resellerMarketing.toApiJson() : this.resellerMarketing;
    }
    if (typeof this.endUserMarketing !== 'undefined' && this.endUserMarketing !== null) {
      toReturn['endUserMarketing'] = 'toApiJson' in this.endUserMarketing ? this.endUserMarketing.toApiJson() : this.endUserMarketing;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.allowPriceNegotiation !== 'undefined') {
      toReturn['allowPriceNegotiation'] = this.allowPriceNegotiation;
    }
    if (typeof this.restrictions !== 'undefined' && this.restrictions !== null) {
      toReturn['restrictions'] = 'toApiJson' in this.restrictions ? this.restrictions.toApiJson() : this.restrictions;
    }
    if (typeof this.billingId !== 'undefined') {
      toReturn['billingId'] = this.billingId;
    }
    if (typeof this.gdprCompliant !== 'undefined') {
      toReturn['gdprCompliant'] = this.gdprCompliant;
    }
    if (typeof this.preventPriceConversionBetweenCurrencies !== 'undefined') {
      toReturn['preventPriceConversionBetweenCurrencies'] = this.preventPriceConversionBetweenCurrencies;
    }
    if (typeof this.suggestedRetailPrice !== 'undefined') {
      toReturn['suggestedRetailPrice'] = this.suggestedRetailPrice;
    }
    if (typeof this.commitment !== 'undefined' && this.commitment !== null) {
      toReturn['commitment'] = 'toApiJson' in this.commitment ? this.commitment.toApiJson() : this.commitment;
    }
    if (typeof this.vendorId !== 'undefined') {
      toReturn['vendorId'] = this.vendorId;
    }
    if (typeof this.multipleActivations !== 'undefined') {
      toReturn['multipleActivations'] = this.multipleActivations;
    }
    if (typeof this.usesActivationSpecificEntryUrl !== 'undefined') {
      toReturn['usesActivationSpecificEntryUrl'] = this.usesActivationSpecificEntryUrl;
    }
    if (typeof this.usesResellerMarketing !== 'undefined') {
      toReturn['usesResellerMarketing'] = this.usesResellerMarketing;
    }
    if (typeof this.usesIntegration !== 'undefined') {
      toReturn['usesIntegration'] = this.usesIntegration;
    }
    if (typeof this.usesEditions !== 'undefined') {
      toReturn['usesEditions'] = this.usesEditions;
    }
    if (typeof this.usesSsoIntegration !== 'undefined') {
      toReturn['usesSsoIntegration'] = this.usesSsoIntegration;
    }
    if (typeof this.editionIds !== 'undefined') {
      toReturn['editionIds'] = this.editionIds;
    }
    if (typeof this.discoverable !== 'undefined') {
      toReturn['discoverable'] = this.discoverable;
    }
    if (typeof this.trialConfiguration !== 'undefined' && this.trialConfiguration !== null) {
      toReturn['trialConfiguration'] = 'toApiJson' in this.trialConfiguration ? this.trialConfiguration.toApiJson() : this.trialConfiguration;
    }
    if (typeof this.applicationUrl !== 'undefined') {
      toReturn['applicationUrl'] = this.applicationUrl;
    }
    if (typeof this.state !== 'undefined') {
      toReturn['state'] = this.state;
    }
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    if (typeof this.cost !== 'undefined' && this.cost !== null) {
      toReturn['cost'] = 'toApiJson' in this.cost ? this.cost.toApiJson() : this.cost;
    }
    if (typeof this.billingProcess !== 'undefined') {
      toReturn['billingProcess'] = this.billingProcess;
    }
    if (typeof this.setupFee !== 'undefined') {
      toReturn['setupFee'] = this.setupFee;
    }
    if (typeof this.suspended !== 'undefined' && this.suspended !== null) {
      toReturn['suspended'] = 'toApiJson' in this.suspended ? this.suspended.toApiJson() : this.suspended;
    }
    if (typeof this.usesCustomPricing !== 'undefined') {
      toReturn['usesCustomPricing'] = this.usesCustomPricing;
    }
    if (typeof this.usesFulfillmentIntegration !== 'undefined') {
      toReturn['usesFulfillmentIntegration'] = this.usesFulfillmentIntegration;
    }
    if (typeof this.deliveryMethod !== 'undefined') {
      toReturn['deliveryMethod'] = this.deliveryMethod;
    }
    if (typeof this.categories !== 'undefined') {
      toReturn['categories'] = this.categories;
    }
    return toReturn;
  }
}
class MarketplaceAppProduct {
  static fromProto(proto) {
    let m = new MarketplaceAppProduct();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    return toReturn;
  }
}
class TrialConfiguration {
  static fromProto(proto) {
    let m = new TrialConfiguration();
    m = Object.assign(m, proto);
    if (proto.endOfTrialAction) {
      m.endOfTrialAction = enumStringToValue$8(EndOfTrialActions, proto.endOfTrialAction);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.trialEnabled !== 'undefined') {
      toReturn['trialEnabled'] = this.trialEnabled;
    }
    if (typeof this.trialDuration !== 'undefined') {
      toReturn['trialDuration'] = this.trialDuration;
    }
    if (typeof this.endOfTrialAction !== 'undefined') {
      toReturn['endOfTrialAction'] = this.endOfTrialAction;
    }
    return toReturn;
  }
}
function enumStringToValue$7(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Addon {
  static fromProto(proto) {
    let m = new Addon();
    m = Object.assign(m, proto);
    if (proto.price) {
      m.price = parseInt(proto.price, 10);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.orderForm) {
      m.orderForm = OrderForm.fromProto(proto.orderForm);
    }
    if (proto.resellerMarketing) {
      m.resellerMarketing = MarketingInformation.fromProto(proto.resellerMarketing);
    }
    if (proto.endUserMarketing) {
      m.endUserMarketing = MarketingInformation.fromProto(proto.endUserMarketing);
    }
    if (proto.restrictions) {
      m.restrictions = Restrictions.fromProto(proto.restrictions);
    }
    if (proto.suggestedRetailPrice) {
      m.suggestedRetailPrice = parseInt(proto.suggestedRetailPrice, 10);
    }
    if (proto.commitment) {
      m.commitment = Commitment.fromProto(proto.commitment);
    }
    if (proto.setupFee) {
      m.setupFee = parseInt(proto.setupFee, 10);
    }
    if (proto.suspended) {
      m.suspended = new Date(proto.suspended);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.addonId !== 'undefined') {
      toReturn['addonId'] = this.addonId;
    }
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.tagline !== 'undefined') {
      toReturn['tagline'] = this.tagline;
    }
    if (typeof this.price !== 'undefined') {
      toReturn['price'] = this.price;
    }
    if (typeof this.title !== 'undefined') {
      toReturn['title'] = this.title;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.orderForm !== 'undefined' && this.orderForm !== null) {
      toReturn['orderForm'] = 'toApiJson' in this.orderForm ? this.orderForm.toApiJson() : this.orderForm;
    }
    if (typeof this.usesOrderForm !== 'undefined') {
      toReturn['usesOrderForm'] = this.usesOrderForm;
    }
    if (typeof this.approved !== 'undefined') {
      toReturn['approved'] = this.approved;
    }
    if (typeof this.icon !== 'undefined') {
      toReturn['icon'] = this.icon;
    }
    if (typeof this.bannerImage !== 'undefined') {
      toReturn['bannerImage'] = this.bannerImage;
    }
    if (typeof this.resellerMarketing !== 'undefined' && this.resellerMarketing !== null) {
      toReturn['resellerMarketing'] = 'toApiJson' in this.resellerMarketing ? this.resellerMarketing.toApiJson() : this.resellerMarketing;
    }
    if (typeof this.endUserMarketing !== 'undefined' && this.endUserMarketing !== null) {
      toReturn['endUserMarketing'] = 'toApiJson' in this.endUserMarketing ? this.endUserMarketing.toApiJson() : this.endUserMarketing;
    }
    if (typeof this.billingFrequency !== 'undefined') {
      toReturn['billingFrequency'] = this.billingFrequency;
    }
    if (typeof this.serviceModel !== 'undefined') {
      toReturn['serviceModel'] = this.serviceModel;
    }
    if (typeof this.discoverable !== 'undefined') {
      toReturn['discoverable'] = this.discoverable;
    }
    if (typeof this.screenshots !== 'undefined') {
      toReturn['screenshots'] = this.screenshots;
    }
    if (typeof this.multipleActivations !== 'undefined') {
      toReturn['multipleActivations'] = this.multipleActivations;
    }
    if (typeof this.restrictions !== 'undefined' && this.restrictions !== null) {
      toReturn['restrictions'] = 'toApiJson' in this.restrictions ? this.restrictions.toApiJson() : this.restrictions;
    }
    if (typeof this.activationRequiresApproval !== 'undefined') {
      toReturn['activationRequiresApproval'] = this.activationRequiresApproval;
    }
    if (typeof this.billingId !== 'undefined') {
      toReturn['billingId'] = this.billingId;
    }
    if (typeof this.preventPriceConversionBetweenCurrencies !== 'undefined') {
      toReturn['preventPriceConversionBetweenCurrencies'] = this.preventPriceConversionBetweenCurrencies;
    }
    if (typeof this.suggestedRetailPrice !== 'undefined') {
      toReturn['suggestedRetailPrice'] = this.suggestedRetailPrice;
    }
    if (typeof this.commitment !== 'undefined' && this.commitment !== null) {
      toReturn['commitment'] = 'toApiJson' in this.commitment ? this.commitment.toApiJson() : this.commitment;
    }
    if (typeof this.currency !== 'undefined') {
      toReturn['currency'] = this.currency;
    }
    if (typeof this.setupFee !== 'undefined') {
      toReturn['setupFee'] = this.setupFee;
    }
    if (typeof this.suspended !== 'undefined' && this.suspended !== null) {
      toReturn['suspended'] = 'toApiJson' in this.suspended ? this.suspended.toApiJson() : this.suspended;
    }
    if (typeof this.usesCustomPricing !== 'undefined') {
      toReturn['usesCustomPricing'] = this.usesCustomPricing;
    }
    return toReturn;
  }
}
function enumStringToValue$6(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Access {
  static fromProto(proto) {
    let m = new Access();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.scope !== 'undefined') {
      toReturn['scope'] = this.scope;
    }
    if (typeof this.public !== 'undefined') {
      toReturn['public'] = this.public;
    }
    return toReturn;
  }
}
function enumStringToValue$5(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class FieldMask {
  static fromProto(proto) {
    let m = new FieldMask();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.paths !== 'undefined') {
      toReturn['paths'] = this.paths;
    }
    return toReturn;
  }
}
function enumStringToValue$4(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class AppVendor {
  static fromProto(proto) {
    let m = new AppVendor();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.appIds !== 'undefined') {
      toReturn['appIds'] = this.appIds;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.reportingCode !== 'undefined') {
      toReturn['reportingCode'] = this.reportingCode;
    }
    return toReturn;
  }
}
function enumStringToValue$3(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class ProductCostEditionCostEntry {
  static fromProto(proto) {
    let m = new ProductCostEditionCostEntry();
    m = Object.assign(m, proto);
    if (proto.value) {
      m.value = ProductCost.fromProto(proto.value);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined' && this.value !== null) {
      toReturn['value'] = 'toApiJson' in this.value ? this.value.toApiJson() : this.value;
    }
    return toReturn;
  }
}
class ProductCost {
  static fromProto(proto) {
    let m = new ProductCost();
    m = Object.assign(m, proto);
    if (proto.cost) {
      m.cost = parseInt(proto.cost, 10);
    }
    if (proto.commitment) {
      m.commitment = Commitment.fromProto(proto.commitment);
    }
    if (proto.editionCost) {
      m.editionCost = Object.keys(proto.editionCost).reduce((obj, k) => {
        obj[k] = ProductCost.fromProto(proto.editionCost[k]);
        return obj;
      }, {});
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.currency !== 'undefined') {
      toReturn['currency'] = this.currency;
    }
    if (typeof this.frequency !== 'undefined') {
      toReturn['frequency'] = this.frequency;
    }
    if (typeof this.cost !== 'undefined') {
      toReturn['cost'] = this.cost;
    }
    if (typeof this.commitment !== 'undefined' && this.commitment !== null) {
      toReturn['commitment'] = 'toApiJson' in this.commitment ? this.commitment.toApiJson() : this.commitment;
    }
    if (typeof this.isWholesale !== 'undefined') {
      toReturn['isWholesale'] = this.isWholesale;
    }
    if (typeof this.editionCost !== 'undefined' && this.editionCost !== null) {
      toReturn['editionCost'] = 'toApiJson' in this.editionCost ? this.editionCost.toApiJson() : this.editionCost;
    }
    return toReturn;
  }
}
function enumStringToValue$2(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class ActiveAppEditionIdentifier {
  static fromProto(proto) {
    let m = new ActiveAppEditionIdentifier();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.editionId !== 'undefined') {
      toReturn['editionId'] = this.editionId;
    }
    return toReturn;
  }
}
class AddAppIDRequest {
  static fromProto(proto) {
    let m = new AddAppIDRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    return toReturn;
  }
}
class AddAppIDResponse {
  static fromProto(proto) {
    let m = new AddAppIDResponse();
    m = Object.assign(m, proto);
    if (proto.vendor) {
      m.vendor = AppVendor.fromProto(proto.vendor);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.vendor !== 'undefined' && this.vendor !== null) {
      toReturn['vendor'] = 'toApiJson' in this.vendor ? this.vendor.toApiJson() : this.vendor;
    }
    return toReturn;
  }
}
class AddonResponse {
  static fromProto(proto) {
    let m = new AddonResponse();
    m = Object.assign(m, proto);
    if (proto.addon) {
      m.addon = Addon.fromProto(proto.addon);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.addon !== 'undefined' && this.addon !== null) {
      toReturn['addon'] = 'toApiJson' in this.addon ? this.addon.toApiJson() : this.addon;
    }
    return toReturn;
  }
}
class AddonsListResponse {
  static fromProto(proto) {
    let m = new AddonsListResponse();
    m = Object.assign(m, proto);
    if (proto.addons) {
      m.addons = proto.addons.map(Addon.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.addons !== 'undefined' && this.addons !== null) {
      toReturn['addons'] = 'toApiJson' in this.addons ? this.addons.toApiJson() : this.addons;
    }
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    return toReturn;
  }
}
class AppResponse {
  static fromProto(proto) {
    let m = new AppResponse();
    m = Object.assign(m, proto);
    if (proto.app) {
      m.app = MarketplaceApp.fromProto(proto.app);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.app !== 'undefined' && this.app !== null) {
      toReturn['app'] = 'toApiJson' in this.app ? this.app.toApiJson() : this.app;
    }
    return toReturn;
  }
}
class ApproveAddonRequest {
  static fromProto(proto) {
    let m = new ApproveAddonRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.addonId !== 'undefined') {
      toReturn['addonId'] = this.addonId;
    }
    return toReturn;
  }
}
class ApproveAppRequest {
  static fromProto(proto) {
    let m = new ApproveAppRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    return toReturn;
  }
}
class CanActivateRequest {
  static fromProto(proto) {
    let m = new CanActivateRequest();
    m = Object.assign(m, proto);
    if (proto.activeAppEditionIds) {
      m.activeAppEditionIds = proto.activeAppEditionIds.map(ActiveAppEditionIdentifier.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appIds !== 'undefined') {
      toReturn['appIds'] = this.appIds;
    }
    if (typeof this.activeAppIds !== 'undefined') {
      toReturn['activeAppIds'] = this.activeAppIds;
    }
    if (typeof this.activeAppEditionIds !== 'undefined' && this.activeAppEditionIds !== null) {
      toReturn['activeAppEditionIds'] = 'toApiJson' in this.activeAppEditionIds ? this.activeAppEditionIds.toApiJson() : this.activeAppEditionIds;
    }
    return toReturn;
  }
}
class CanActivateResponse {
  static fromProto(proto) {
    let m = new CanActivateResponse();
    m = Object.assign(m, proto);
    if (proto.invalidResponse) {
      m.invalidResponse = CanActivateResponseInvalidResponse.fromProto(proto.invalidResponse);
    }
    if (proto.successResponse) {
      m.successResponse = CanActivateResponseSuccessResponse.fromProto(proto.successResponse);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.invalidResponse !== 'undefined' && this.invalidResponse !== null) {
      toReturn['invalidResponse'] = 'toApiJson' in this.invalidResponse ? this.invalidResponse.toApiJson() : this.invalidResponse;
    }
    if (typeof this.successResponse !== 'undefined' && this.successResponse !== null) {
      toReturn['successResponse'] = 'toApiJson' in this.successResponse ? this.successResponse.toApiJson() : this.successResponse;
    }
    return toReturn;
  }
}
class CreateAppRequest {
  static fromProto(proto) {
    let m = new CreateAppRequest();
    m = Object.assign(m, proto);
    if (proto.lmiCategories) {
      m.lmiCategories = proto.lmiCategories.map(v => enumStringToValue$2(MarketplaceAppLmiLmiCategories, v));
    }
    if (proto.price) {
      m.price = parseInt(proto.price, 10);
    }
    if (proto.restrictions) {
      m.restrictions = Restrictions.fromProto(proto.restrictions);
    }
    if (proto.orderForm) {
      m.orderForm = OrderForm.fromProto(proto.orderForm);
    }
    if (proto.resellerMarketing) {
      m.resellerMarketing = MarketingInformation.fromProto(proto.resellerMarketing);
    }
    if (proto.endUserMarketing) {
      m.endUserMarketing = MarketingInformation.fromProto(proto.endUserMarketing);
    }
    if (proto.suggestedRetailPrice) {
      m.suggestedRetailPrice = parseInt(proto.suggestedRetailPrice, 10);
    }
    if (proto.country) {
      m.country = PermissionLists.fromProto(proto.country);
    }
    if (proto.commitment) {
      m.commitment = Commitment.fromProto(proto.commitment);
    }
    if (proto.distributionSetting) {
      m.distributionSetting = enumStringToValue$2(DistributionSetting, proto.distributionSetting);
    }
    if (proto.state) {
      m.state = enumStringToValue$2(State, proto.state);
    }
    if (proto.cost) {
      m.cost = Cost.fromProto(proto.cost);
    }
    if (proto.setupFee) {
      m.setupFee = parseInt(proto.setupFee, 10);
    }
    if (proto.deliveryMethod) {
      m.deliveryMethod = enumStringToValue$2(DeliveryMethod, proto.deliveryMethod);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.vendor !== 'undefined') {
      toReturn['vendor'] = this.vendor;
    }
    if (typeof this.tagline !== 'undefined') {
      toReturn['tagline'] = this.tagline;
    }
    if (typeof this.serviceModel !== 'undefined') {
      toReturn['serviceModel'] = this.serviceModel;
    }
    if (typeof this.lmiCategories !== 'undefined') {
      toReturn['lmiCategories'] = this.lmiCategories;
    }
    if (typeof this.icon !== 'undefined') {
      toReturn['icon'] = this.icon;
    }
    if (typeof this.headerImage !== 'undefined') {
      toReturn['headerImage'] = this.headerImage;
    }
    if (typeof this.screenshot !== 'undefined') {
      toReturn['screenshot'] = this.screenshot;
    }
    if (typeof this.price !== 'undefined') {
      toReturn['price'] = this.price;
    }
    if (typeof this.currency !== 'undefined') {
      toReturn['currency'] = this.currency;
    }
    if (typeof this.billingFrequency !== 'undefined') {
      toReturn['billingFrequency'] = this.billingFrequency;
    }
    if (typeof this.restrictions !== 'undefined' && this.restrictions !== null) {
      toReturn['restrictions'] = 'toApiJson' in this.restrictions ? this.restrictions.toApiJson() : this.restrictions;
    }
    if (typeof this.allowPriceNegotiation !== 'undefined') {
      toReturn['allowPriceNegotiation'] = this.allowPriceNegotiation;
    }
    if (typeof this.publicKey !== 'undefined') {
      toReturn['publicKey'] = this.publicKey;
    }
    if (typeof this.reserveIdUrl !== 'undefined') {
      toReturn['reserveIdUrl'] = this.reserveIdUrl;
    }
    if (typeof this.purchaseWebhookUrl !== 'undefined') {
      toReturn['purchaseWebhookUrl'] = this.purchaseWebhookUrl;
    }
    if (typeof this.activationRequiresApproval !== 'undefined') {
      toReturn['activationRequiresApproval'] = this.activationRequiresApproval;
    }
    if (typeof this.addonPurchaseWebhookUrl !== 'undefined') {
      toReturn['addonPurchaseWebhookUrl'] = this.addonPurchaseWebhookUrl;
    }
    if (typeof this.userModWebhookUrl !== 'undefined') {
      toReturn['userModWebhookUrl'] = this.userModWebhookUrl;
    }
    if (typeof this.accountModWebhookUrl !== 'undefined') {
      toReturn['accountModWebhookUrl'] = this.accountModWebhookUrl;
    }
    if (typeof this.contactWebhookUrl !== 'undefined') {
      toReturn['contactWebhookUrl'] = this.contactWebhookUrl;
    }
    if (typeof this.fulfillmentEmail !== 'undefined') {
      toReturn['fulfillmentEmail'] = this.fulfillmentEmail;
    }
    if (typeof this.entryUrl !== 'undefined') {
      toReturn['entryUrl'] = this.entryUrl;
    }
    if (typeof this.sessionUrl !== 'undefined') {
      toReturn['sessionUrl'] = this.sessionUrl;
    }
    if (typeof this.logoutUrl !== 'undefined') {
      toReturn['logoutUrl'] = this.logoutUrl;
    }
    if (typeof this.usesOrderForm !== 'undefined') {
      toReturn['usesOrderForm'] = this.usesOrderForm;
    }
    if (typeof this.orderForm !== 'undefined' && this.orderForm !== null) {
      toReturn['orderForm'] = 'toApiJson' in this.orderForm ? this.orderForm.toApiJson() : this.orderForm;
    }
    if (typeof this.resellerMarketing !== 'undefined' && this.resellerMarketing !== null) {
      toReturn['resellerMarketing'] = 'toApiJson' in this.resellerMarketing ? this.resellerMarketing.toApiJson() : this.resellerMarketing;
    }
    if (typeof this.endUserMarketing !== 'undefined' && this.endUserMarketing !== null) {
      toReturn['endUserMarketing'] = 'toApiJson' in this.endUserMarketing ? this.endUserMarketing.toApiJson() : this.endUserMarketing;
    }
    if (typeof this.preventPriceConversionBetweenCurrencies !== 'undefined') {
      toReturn['preventPriceConversionBetweenCurrencies'] = this.preventPriceConversionBetweenCurrencies;
    }
    if (typeof this.partnerSettingsWebhookUrl !== 'undefined') {
      toReturn['partnerSettingsWebhookUrl'] = this.partnerSettingsWebhookUrl;
    }
    if (typeof this.suggestedRetailPrice !== 'undefined') {
      toReturn['suggestedRetailPrice'] = this.suggestedRetailPrice;
    }
    if (typeof this.country !== 'undefined' && this.country !== null) {
      toReturn['country'] = 'toApiJson' in this.country ? this.country.toApiJson() : this.country;
    }
    if (typeof this.commitment !== 'undefined' && this.commitment !== null) {
      toReturn['commitment'] = 'toApiJson' in this.commitment ? this.commitment.toApiJson() : this.commitment;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.vendorId !== 'undefined') {
      toReturn['vendorId'] = this.vendorId;
    }
    if (typeof this.customAppId !== 'undefined') {
      toReturn['customAppId'] = this.customAppId;
    }
    if (typeof this.multipleActivations !== 'undefined') {
      toReturn['multipleActivations'] = this.multipleActivations;
    }
    if (typeof this.usesActivationSpecificEntryUrl !== 'undefined') {
      toReturn['usesActivationSpecificEntryUrl'] = this.usesActivationSpecificEntryUrl;
    }
    if (typeof this.usesResellerMarketing !== 'undefined') {
      toReturn['usesResellerMarketing'] = this.usesResellerMarketing;
    }
    if (typeof this.usesIntegration !== 'undefined') {
      toReturn['usesIntegration'] = this.usesIntegration;
    }
    if (typeof this.usesEditions !== 'undefined') {
      toReturn['usesEditions'] = this.usesEditions;
    }
    if (typeof this.usesSsoIntegration !== 'undefined') {
      toReturn['usesSsoIntegration'] = this.usesSsoIntegration;
    }
    if (typeof this.discoverable !== 'undefined') {
      toReturn['discoverable'] = this.discoverable;
    }
    if (typeof this.distributionSetting !== 'undefined') {
      toReturn['distributionSetting'] = this.distributionSetting;
    }
    if (typeof this.orderFormValidatorWebhookUrl !== 'undefined') {
      toReturn['orderFormValidatorWebhookUrl'] = this.orderFormValidatorWebhookUrl;
    }
    if (typeof this.applicationUrl !== 'undefined') {
      toReturn['applicationUrl'] = this.applicationUrl;
    }
    if (typeof this.allowWhiteLabeling !== 'undefined') {
      toReturn['allowWhiteLabeling'] = this.allowWhiteLabeling;
    }
    if (typeof this.state !== 'undefined') {
      toReturn['state'] = this.state;
    }
    if (typeof this.cost !== 'undefined' && this.cost !== null) {
      toReturn['cost'] = 'toApiJson' in this.cost ? this.cost.toApiJson() : this.cost;
    }
    if (typeof this.setupFee !== 'undefined') {
      toReturn['setupFee'] = this.setupFee;
    }
    if (typeof this.usesCustomPricing !== 'undefined') {
      toReturn['usesCustomPricing'] = this.usesCustomPricing;
    }
    if (typeof this.customerWebhookUrl !== 'undefined') {
      toReturn['customerWebhookUrl'] = this.customerWebhookUrl;
    }
    if (typeof this.sendCancelationNotifications !== 'undefined') {
      toReturn['sendCancelationNotifications'] = this.sendCancelationNotifications;
    }
    if (typeof this.cancellationWebhookUrl !== 'undefined') {
      toReturn['cancellationWebhookUrl'] = this.cancellationWebhookUrl;
    }
    if (typeof this.deliveryMethod !== 'undefined') {
      toReturn['deliveryMethod'] = this.deliveryMethod;
    }
    if (typeof this.serviceChangeWebhookUrl !== 'undefined') {
      toReturn['serviceChangeWebhookUrl'] = this.serviceChangeWebhookUrl;
    }
    if (typeof this.appLevelHasAdminDashboard !== 'undefined') {
      toReturn['appLevelHasAdminDashboard'] = this.appLevelHasAdminDashboard;
    }
    return toReturn;
  }
}
class CreateVendorRequest {
  static fromProto(proto) {
    let m = new CreateVendorRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class CreateVendorResponse {
  static fromProto(proto) {
    let m = new CreateVendorResponse();
    m = Object.assign(m, proto);
    if (proto.vendor) {
      m.vendor = AppVendor.fromProto(proto.vendor);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.vendor !== 'undefined' && this.vendor !== null) {
      toReturn['vendor'] = 'toApiJson' in this.vendor ? this.vendor.toApiJson() : this.vendor;
    }
    return toReturn;
  }
}
class DeleteAppRequest {
  static fromProto(proto) {
    let m = new DeleteAppRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    return toReturn;
  }
}
class DuplicateAppRequest {
  static fromProto(proto) {
    let m = new DuplicateAppRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    return toReturn;
  }
}
class DuplicateAppResponse {
  static fromProto(proto) {
    let m = new DuplicateAppResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    return toReturn;
  }
}
class GetAddonRequest {
  static fromProto(proto) {
    let m = new GetAddonRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.addonId !== 'undefined') {
      toReturn['addonId'] = this.addonId;
    }
    return toReturn;
  }
}
class GetAppIDFromSkuRequest {
  static fromProto(proto) {
    let m = new GetAppIDFromSkuRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sku !== 'undefined') {
      toReturn['sku'] = this.sku;
    }
    return toReturn;
  }
}
class GetAppIDFromSkuResponse {
  static fromProto(proto) {
    let m = new GetAppIDFromSkuResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.addonId !== 'undefined') {
      toReturn['addonId'] = this.addonId;
    }
    if (typeof this.editionId !== 'undefined') {
      toReturn['editionId'] = this.editionId;
    }
    return toReturn;
  }
}
class GetAppRequest {
  static fromProto(proto) {
    let m = new GetAppRequest();
    m = Object.assign(m, proto);
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    if (typeof this.bypassCache !== 'undefined') {
      toReturn['bypassCache'] = this.bypassCache;
    }
    return toReturn;
  }
}
class GetAppResponse {
  static fromProto(proto) {
    let m = new GetAppResponse();
    m = Object.assign(m, proto);
    if (proto.app) {
      m.app = MarketplaceApp.fromProto(proto.app);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.app !== 'undefined' && this.app !== null) {
      toReturn['app'] = 'toApiJson' in this.app ? this.app.toApiJson() : this.app;
    }
    return toReturn;
  }
}
class GetAppsToDeactivateUponDeactivationRequest {
  static fromProto(proto) {
    let m = new GetAppsToDeactivateUponDeactivationRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appIdsToDeactivate !== 'undefined') {
      toReturn['appIdsToDeactivate'] = this.appIdsToDeactivate;
    }
    if (typeof this.activeAppIds !== 'undefined') {
      toReturn['activeAppIds'] = this.activeAppIds;
    }
    return toReturn;
  }
}
class GetAppsToDeactivateUponDeactivationResponse {
  static fromProto(proto) {
    let m = new GetAppsToDeactivateUponDeactivationResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appIdsToBeDeactivated !== 'undefined') {
      toReturn['appIdsToBeDeactivated'] = this.appIdsToBeDeactivated;
    }
    return toReturn;
  }
}
class GetAppsWithUnpublishedChangesRequest {
  static fromProto(proto) {
    let m = new GetAppsWithUnpublishedChangesRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    return toReturn;
  }
}
class GetAppsWithUnpublishedChangesResponse {
  static fromProto(proto) {
    let m = new GetAppsWithUnpublishedChangesResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appIds !== 'undefined') {
      toReturn['appIds'] = this.appIds;
    }
    return toReturn;
  }
}
class GetByPartnerIDRequest {
  static fromProto(proto) {
    let m = new GetByPartnerIDRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class GetByPartnerIDResponse {
  static fromProto(proto) {
    let m = new GetByPartnerIDResponse();
    m = Object.assign(m, proto);
    if (proto.vendor) {
      m.vendor = AppVendor.fromProto(proto.vendor);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.vendor !== 'undefined' && this.vendor !== null) {
      toReturn['vendor'] = 'toApiJson' in this.vendor ? this.vendor.toApiJson() : this.vendor;
    }
    return toReturn;
  }
}
class GetMultiAppRequest {
  static fromProto(proto) {
    let m = new GetMultiAppRequest();
    m = Object.assign(m, proto);
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    return toReturn;
  }
}
class GetMultiAppResponse {
  static fromProto(proto) {
    let m = new GetMultiAppResponse();
    m = Object.assign(m, proto);
    if (proto.apps) {
      m.apps = proto.apps.map(MarketplaceApp.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.apps !== 'undefined' && this.apps !== null) {
      toReturn['apps'] = 'toApiJson' in this.apps ? this.apps.toApiJson() : this.apps;
    }
    return toReturn;
  }
}
class GetMultiOrderFormsRequest {
  static fromProto(proto) {
    let m = new GetMultiOrderFormsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.appIds !== 'undefined') {
      toReturn['appIds'] = this.appIds;
    }
    return toReturn;
  }
}
class GetMultiOrderFormsResponse {
  static fromProto(proto) {
    let m = new GetMultiOrderFormsResponse();
    m = Object.assign(m, proto);
    if (proto.orderFormContainer) {
      m.orderFormContainer = proto.orderFormContainer.map(GetMultiOrderFormsResponseOrderFormContainer.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.orderFormContainer !== 'undefined' && this.orderFormContainer !== null) {
      toReturn['orderFormContainer'] = 'toApiJson' in this.orderFormContainer ? this.orderFormContainer.toApiJson() : this.orderFormContainer;
    }
    return toReturn;
  }
}
class GetMultiProductCostRequest {
  static fromProto(proto) {
    let m = new GetMultiProductCostRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.appIds !== 'undefined') {
      toReturn['appIds'] = this.appIds;
    }
    return toReturn;
  }
}
class GetMultiProductCostResponse {
  static fromProto(proto) {
    let m = new GetMultiProductCostResponse();
    m = Object.assign(m, proto);
    if (proto.productCost) {
      m.productCost = Object.keys(proto.productCost).reduce((obj, k) => {
        obj[k] = ProductCost.fromProto(proto.productCost[k]);
        return obj;
      }, {});
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.productCost !== 'undefined' && this.productCost !== null) {
      toReturn['productCost'] = 'toApiJson' in this.productCost ? this.productCost.toApiJson() : this.productCost;
    }
    return toReturn;
  }
}
class GetMultiVendorRequest {
  static fromProto(proto) {
    let m = new GetMultiVendorRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.ids !== 'undefined') {
      toReturn['ids'] = this.ids;
    }
    return toReturn;
  }
}
class GetMultiVendorResponse {
  static fromProto(proto) {
    let m = new GetMultiVendorResponse();
    m = Object.assign(m, proto);
    if (proto.vendors) {
      m.vendors = proto.vendors.map(AppVendor.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.vendors !== 'undefined' && this.vendors !== null) {
      toReturn['vendors'] = 'toApiJson' in this.vendors ? this.vendors.toApiJson() : this.vendors;
    }
    return toReturn;
  }
}
class GetOwnedAppIDsByPartnerIDRequest {
  static fromProto(proto) {
    let m = new GetOwnedAppIDsByPartnerIDRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class GetOwnedAppIDsByPartnerIDResponse {
  static fromProto(proto) {
    let m = new GetOwnedAppIDsByPartnerIDResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appIds !== 'undefined') {
      toReturn['appIds'] = this.appIds;
    }
    return toReturn;
  }
}
class GetPublicKeysRequest {
  static fromProto(proto) {
    let m = new GetPublicKeysRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    return toReturn;
  }
}
class GetPublicKeysResponse {
  static fromProto(proto) {
    let m = new GetPublicKeysResponse();
    m = Object.assign(m, proto);
    if (proto.identifiedPublicKeys) {
      m.identifiedPublicKeys = proto.identifiedPublicKeys.map(IdentifiedPublicKey.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.publicKey !== 'undefined') {
      toReturn['publicKey'] = this.publicKey;
    }
    if (typeof this.identifiedPublicKeys !== 'undefined' && this.identifiedPublicKeys !== null) {
      toReturn['identifiedPublicKeys'] = 'toApiJson' in this.identifiedPublicKeys ? this.identifiedPublicKeys.toApiJson() : this.identifiedPublicKeys;
    }
    return toReturn;
  }
}
class GetSSOUrlsRequest {
  static fromProto(proto) {
    let m = new GetSSOUrlsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    return toReturn;
  }
}
class GetSSOUrlsResponse {
  static fromProto(proto) {
    let m = new GetSSOUrlsResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.entryUrl !== 'undefined') {
      toReturn['entryUrl'] = this.entryUrl;
    }
    if (typeof this.sessionUrl !== 'undefined') {
      toReturn['sessionUrl'] = this.sessionUrl;
    }
    return toReturn;
  }
}
class CanActivateResponseInvalidResponse {
  static fromProto(proto) {
    let m = new CanActivateResponseInvalidResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.invalidAppIds !== 'undefined') {
      toReturn['invalidAppIds'] = this.invalidAppIds;
    }
    return toReturn;
  }
}
class IsVendorDistributedByPartnerIDRequest {
  static fromProto(proto) {
    let m = new IsVendorDistributedByPartnerIDRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class IsVendorDistributedByPartnerIDResponse {
  static fromProto(proto) {
    let m = new IsVendorDistributedByPartnerIDResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.isDistributed !== 'undefined') {
      toReturn['isDistributed'] = this.isDistributed;
    }
    return toReturn;
  }
}
class ListAddonsRequest {
  static fromProto(proto) {
    let m = new ListAddonsRequest();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    return toReturn;
  }
}
class ListApprovedAddonsRequest {
  static fromProto(proto) {
    let m = new ListApprovedAddonsRequest();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    if (typeof this.appIds !== 'undefined') {
      toReturn['appIds'] = this.appIds;
    }
    return toReturn;
  }
}
class ListAppsRequestListAppsFilter {
  static fromProto(proto) {
    let m = new ListAppsRequestListAppsFilter();
    m = Object.assign(m, proto);
    if (proto.appType) {
      m.appType = enumStringToValue$2(AppType, proto.appType);
    }
    if (proto.releaseType) {
      m.releaseType = enumStringToValue$2(ReleaseType, proto.releaseType);
    }
    if (proto.state) {
      m.state = enumStringToValue$2(StateFilterOptions, proto.state);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appType !== 'undefined') {
      toReturn['appType'] = this.appType;
    }
    if (typeof this.releaseType !== 'undefined') {
      toReturn['releaseType'] = this.releaseType;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.filterTerm !== 'undefined') {
      toReturn['filterTerm'] = this.filterTerm;
    }
    if (typeof this.state !== 'undefined') {
      toReturn['state'] = this.state;
    }
    return toReturn;
  }
}
class ListAppsForVendorIDsRequest {
  static fromProto(proto) {
    let m = new ListAppsForVendorIDsRequest();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.vendorIds !== 'undefined') {
      toReturn['vendorIds'] = this.vendorIds;
    }
    if (typeof this.includeAddons !== 'undefined') {
      toReturn['includeAddons'] = this.includeAddons;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    return toReturn;
  }
}
class ListAppsForVendorIDsResponse {
  static fromProto(proto) {
    let m = new ListAppsForVendorIDsResponse();
    m = Object.assign(m, proto);
    if (proto.apps) {
      m.apps = proto.apps.map(MarketplaceApp.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.apps !== 'undefined' && this.apps !== null) {
      toReturn['apps'] = 'toApiJson' in this.apps ? this.apps.toApiJson() : this.apps;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    return toReturn;
  }
}
class ListAppsRequest {
  static fromProto(proto) {
    let m = new ListAppsRequest();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    if (proto.filter) {
      m.filter = ListAppsRequestListAppsFilter.fromProto(proto.filter);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    if (typeof this.filter !== 'undefined' && this.filter !== null) {
      toReturn['filter'] = 'toApiJson' in this.filter ? this.filter.toApiJson() : this.filter;
    }
    return toReturn;
  }
}
class ListRequiredAppSummariesFilters {
  static fromProto(proto) {
    let m = new ListRequiredAppSummariesFilters();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.searchTerm !== 'undefined') {
      toReturn['searchTerm'] = this.searchTerm;
    }
    return toReturn;
  }
}
class ListRequiredAppSummariesRequest {
  static fromProto(proto) {
    let m = new ListRequiredAppSummariesRequest();
    m = Object.assign(m, proto);
    if (proto.filters) {
      m.filters = ListRequiredAppSummariesFilters.fromProto(proto.filters);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.vendorId !== 'undefined') {
      toReturn['vendorId'] = this.vendorId;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    return toReturn;
  }
}
class ListRequiredAppSummariesResponse {
  static fromProto(proto) {
    let m = new ListRequiredAppSummariesResponse();
    m = Object.assign(m, proto);
    if (proto.requiredAppSummaries) {
      m.requiredAppSummaries = proto.requiredAppSummaries.map(RequiredAppSummary.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.requiredAppSummaries !== 'undefined' && this.requiredAppSummaries !== null) {
      toReturn['requiredAppSummaries'] = 'toApiJson' in this.requiredAppSummaries ? this.requiredAppSummaries.toApiJson() : this.requiredAppSummaries;
    }
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    return toReturn;
  }
}
class ListVendorRequest {
  static fromProto(proto) {
    let m = new ListVendorRequest();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    return toReturn;
  }
}
class ListVendorResponse {
  static fromProto(proto) {
    let m = new ListVendorResponse();
    m = Object.assign(m, proto);
    if (proto.vendors) {
      m.vendors = proto.vendors.map(AppVendor.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.vendors !== 'undefined' && this.vendors !== null) {
      toReturn['vendors'] = 'toApiJson' in this.vendors ? this.vendors.toApiJson() : this.vendors;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    return toReturn;
  }
}
class GetMultiOrderFormsResponseOrderFormContainer {
  static fromProto(proto) {
    let m = new GetMultiOrderFormsResponseOrderFormContainer();
    m = Object.assign(m, proto);
    if (proto.orderForm) {
      m.orderForm = OrderForm.fromProto(proto.orderForm);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.orderForm !== 'undefined' && this.orderForm !== null) {
      toReturn['orderForm'] = 'toApiJson' in this.orderForm ? this.orderForm.toApiJson() : this.orderForm;
    }
    return toReturn;
  }
}
class PagedAppResponse {
  static fromProto(proto) {
    let m = new PagedAppResponse();
    m = Object.assign(m, proto);
    if (proto.apps) {
      m.apps = proto.apps.map(MarketplaceApp.fromProto);
    }
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.apps !== 'undefined' && this.apps !== null) {
      toReturn['apps'] = 'toApiJson' in this.apps ? this.apps.toApiJson() : this.apps;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    return toReturn;
  }
}
class GetMultiProductCostResponseProductCostEntry {
  static fromProto(proto) {
    let m = new GetMultiProductCostResponseProductCostEntry();
    m = Object.assign(m, proto);
    if (proto.value) {
      m.value = ProductCost.fromProto(proto.value);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined' && this.value !== null) {
      toReturn['value'] = 'toApiJson' in this.value ? this.value.toApiJson() : this.value;
    }
    return toReturn;
  }
}
class PublishAppRequest {
  static fromProto(proto) {
    let m = new PublishAppRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    return toReturn;
  }
}
class RemoveAppIDRequest {
  static fromProto(proto) {
    let m = new RemoveAppIDRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    return toReturn;
  }
}
class RemoveAppIDResponse {
  static fromProto(proto) {
    let m = new RemoveAppIDResponse();
    m = Object.assign(m, proto);
    if (proto.vendor) {
      m.vendor = AppVendor.fromProto(proto.vendor);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.vendor !== 'undefined' && this.vendor !== null) {
      toReturn['vendor'] = 'toApiJson' in this.vendor ? this.vendor.toApiJson() : this.vendor;
    }
    return toReturn;
  }
}
class RequestAppReviewRequest {
  static fromProto(proto) {
    let m = new RequestAppReviewRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    return toReturn;
  }
}
class RequiredAppSummary {
  static fromProto(proto) {
    let m = new RequiredAppSummary();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.iconUrl !== 'undefined') {
      toReturn['iconUrl'] = this.iconUrl;
    }
    return toReturn;
  }
}
class RestoreAppRequest {
  static fromProto(proto) {
    let m = new RestoreAppRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    return toReturn;
  }
}
class CanActivateResponseSuccessResponse {
  static fromProto(proto) {
    let m = new CanActivateResponseSuccessResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    return toReturn;
  }
}
class SuspendAppRequest {
  static fromProto(proto) {
    let m = new SuspendAppRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    return toReturn;
  }
}
class UnapproveAddonRequest {
  static fromProto(proto) {
    let m = new UnapproveAddonRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.addonId !== 'undefined') {
      toReturn['addonId'] = this.addonId;
    }
    return toReturn;
  }
}
class UnapproveAppRequest {
  static fromProto(proto) {
    let m = new UnapproveAppRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    return toReturn;
  }
}
class UnsuspendAppRequest {
  static fromProto(proto) {
    let m = new UnsuspendAppRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    return toReturn;
  }
}
class UpdateAppApprovalAndBillingSettingsRequest {
  static fromProto(proto) {
    let m = new UpdateAppApprovalAndBillingSettingsRequest();
    m = Object.assign(m, proto);
    if (proto.approvalProcess) {
      m.approvalProcess = enumStringToValue$2(ApprovalProcess, proto.approvalProcess);
    }
    if (proto.billingProcess) {
      m.billingProcess = enumStringToValue$2(BillingProcess, proto.billingProcess);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.approvalProcess !== 'undefined') {
      toReturn['approvalProcess'] = this.approvalProcess;
    }
    if (typeof this.billingProcess !== 'undefined') {
      toReturn['billingProcess'] = this.billingProcess;
    }
    return toReturn;
  }
}
class UpdateAppCategoriesRequest {
  static fromProto(proto) {
    let m = new UpdateAppCategoriesRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.categoryIds !== 'undefined') {
      toReturn['categoryIds'] = this.categoryIds;
    }
    return toReturn;
  }
}
class UpdateAppFulfillmentIntegrationRequest {
  static fromProto(proto) {
    let m = new UpdateAppFulfillmentIntegrationRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.usesFulfillmentIntegration !== 'undefined') {
      toReturn['usesFulfillmentIntegration'] = this.usesFulfillmentIntegration;
    }
    return toReturn;
  }
}
class UpdateAppGeneralInformationRequest {
  static fromProto(proto) {
    let m = new UpdateAppGeneralInformationRequest();
    m = Object.assign(m, proto);
    if (proto.lmiCategories) {
      m.lmiCategories = proto.lmiCategories.map(v => enumStringToValue$2(MarketplaceAppLmiLmiCategories, v));
    }
    if (proto.price) {
      m.price = parseInt(proto.price, 10);
    }
    if (proto.restrictions) {
      m.restrictions = Restrictions.fromProto(proto.restrictions);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    if (proto.suggestedRetailPrice) {
      m.suggestedRetailPrice = parseInt(proto.suggestedRetailPrice, 10);
    }
    if (proto.country) {
      m.country = PermissionLists.fromProto(proto.country);
    }
    if (proto.commitment) {
      m.commitment = Commitment.fromProto(proto.commitment);
    }
    if (proto.state) {
      m.state = enumStringToValue$2(State, proto.state);
    }
    if (proto.cost) {
      m.cost = Cost.fromProto(proto.cost);
    }
    if (proto.setupFee) {
      m.setupFee = parseInt(proto.setupFee, 10);
    }
    if (proto.suggestedRetailSetupFee) {
      m.suggestedRetailSetupFee = parseInt(proto.suggestedRetailSetupFee, 10);
    }
    if (proto.deliveryMethod) {
      m.deliveryMethod = enumStringToValue$2(DeliveryMethod, proto.deliveryMethod);
    }
    if (proto.fees) {
      m.fees = proto.fees.map(Fee.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.vendor !== 'undefined') {
      toReturn['vendor'] = this.vendor;
    }
    if (typeof this.tagline !== 'undefined') {
      toReturn['tagline'] = this.tagline;
    }
    if (typeof this.serviceModel !== 'undefined') {
      toReturn['serviceModel'] = this.serviceModel;
    }
    if (typeof this.lmiCategories !== 'undefined') {
      toReturn['lmiCategories'] = this.lmiCategories;
    }
    if (typeof this.icon !== 'undefined') {
      toReturn['icon'] = this.icon;
    }
    if (typeof this.headerImage !== 'undefined') {
      toReturn['headerImage'] = this.headerImage;
    }
    if (typeof this.screenshot !== 'undefined') {
      toReturn['screenshot'] = this.screenshot;
    }
    if (typeof this.price !== 'undefined') {
      toReturn['price'] = this.price;
    }
    if (typeof this.currency !== 'undefined') {
      toReturn['currency'] = this.currency;
    }
    if (typeof this.billingFrequency !== 'undefined') {
      toReturn['billingFrequency'] = this.billingFrequency;
    }
    if (typeof this.restrictions !== 'undefined' && this.restrictions !== null) {
      toReturn['restrictions'] = 'toApiJson' in this.restrictions ? this.restrictions.toApiJson() : this.restrictions;
    }
    if (typeof this.allowPriceNegotiation !== 'undefined') {
      toReturn['allowPriceNegotiation'] = this.allowPriceNegotiation;
    }
    if (typeof this.gdprCompliant !== 'undefined') {
      toReturn['gdprCompliant'] = this.gdprCompliant;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    if (typeof this.preventPriceConversionBetweenCurrencies !== 'undefined') {
      toReturn['preventPriceConversionBetweenCurrencies'] = this.preventPriceConversionBetweenCurrencies;
    }
    if (typeof this.suggestedRetailPrice !== 'undefined') {
      toReturn['suggestedRetailPrice'] = this.suggestedRetailPrice;
    }
    if (typeof this.country !== 'undefined' && this.country !== null) {
      toReturn['country'] = 'toApiJson' in this.country ? this.country.toApiJson() : this.country;
    }
    if (typeof this.commitment !== 'undefined' && this.commitment !== null) {
      toReturn['commitment'] = 'toApiJson' in this.commitment ? this.commitment.toApiJson() : this.commitment;
    }
    if (typeof this.multipleActivations !== 'undefined') {
      toReturn['multipleActivations'] = this.multipleActivations;
    }
    if (typeof this.usesEditions !== 'undefined') {
      toReturn['usesEditions'] = this.usesEditions;
    }
    if (typeof this.discoverable !== 'undefined') {
      toReturn['discoverable'] = this.discoverable;
    }
    if (typeof this.editionIds !== 'undefined') {
      toReturn['editionIds'] = this.editionIds;
    }
    if (typeof this.state !== 'undefined') {
      toReturn['state'] = this.state;
    }
    if (typeof this.cost !== 'undefined' && this.cost !== null) {
      toReturn['cost'] = 'toApiJson' in this.cost ? this.cost.toApiJson() : this.cost;
    }
    if (typeof this.setupFee !== 'undefined') {
      toReturn['setupFee'] = this.setupFee;
    }
    if (typeof this.suggestedRetailSetupFee !== 'undefined') {
      toReturn['suggestedRetailSetupFee'] = this.suggestedRetailSetupFee;
    }
    if (typeof this.usesCustomPricing !== 'undefined') {
      toReturn['usesCustomPricing'] = this.usesCustomPricing;
    }
    if (typeof this.deliveryMethod !== 'undefined') {
      toReturn['deliveryMethod'] = this.deliveryMethod;
    }
    if (typeof this.categories !== 'undefined') {
      toReturn['categories'] = this.categories;
    }
    if (typeof this.fees !== 'undefined' && this.fees !== null) {
      toReturn['fees'] = 'toApiJson' in this.fees ? this.fees.toApiJson() : this.fees;
    }
    return toReturn;
  }
}
class UpdateAppIntegrationRequest {
  static fromProto(proto) {
    let m = new UpdateAppIntegrationRequest();
    m = Object.assign(m, proto);
    if (proto.partnerContactRecipients) {
      m.partnerContactRecipients = proto.partnerContactRecipients.map(Contact.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.publicKey !== 'undefined') {
      toReturn['publicKey'] = this.publicKey;
    }
    if (typeof this.reserveIdUrl !== 'undefined') {
      toReturn['reserveIdUrl'] = this.reserveIdUrl;
    }
    if (typeof this.purchaseWebhookUrl !== 'undefined') {
      toReturn['purchaseWebhookUrl'] = this.purchaseWebhookUrl;
    }
    if (typeof this.activationRequiresApproval !== 'undefined') {
      toReturn['activationRequiresApproval'] = this.activationRequiresApproval;
    }
    if (typeof this.addonPurchaseWebhookUrl !== 'undefined') {
      toReturn['addonPurchaseWebhookUrl'] = this.addonPurchaseWebhookUrl;
    }
    if (typeof this.userModWebhookUrl !== 'undefined') {
      toReturn['userModWebhookUrl'] = this.userModWebhookUrl;
    }
    if (typeof this.accountModWebhookUrl !== 'undefined') {
      toReturn['accountModWebhookUrl'] = this.accountModWebhookUrl;
    }
    if (typeof this.contactWebhookUrl !== 'undefined') {
      toReturn['contactWebhookUrl'] = this.contactWebhookUrl;
    }
    if (typeof this.fulfillmentEmail !== 'undefined') {
      toReturn['fulfillmentEmail'] = this.fulfillmentEmail;
    }
    if (typeof this.partnerSettingsWebhookUrl !== 'undefined') {
      toReturn['partnerSettingsWebhookUrl'] = this.partnerSettingsWebhookUrl;
    }
    if (typeof this.partnerContactRecipients !== 'undefined' && this.partnerContactRecipients !== null) {
      toReturn['partnerContactRecipients'] = 'toApiJson' in this.partnerContactRecipients ? this.partnerContactRecipients.toApiJson() : this.partnerContactRecipients;
    }
    if (typeof this.usesIntegration !== 'undefined') {
      toReturn['usesIntegration'] = this.usesIntegration;
    }
    if (typeof this.orderFormValidatorWebhookUrl !== 'undefined') {
      toReturn['orderFormValidatorWebhookUrl'] = this.orderFormValidatorWebhookUrl;
    }
    if (typeof this.allowWhiteLabeling !== 'undefined') {
      toReturn['allowWhiteLabeling'] = this.allowWhiteLabeling;
    }
    if (typeof this.customerWebhookUrl !== 'undefined') {
      toReturn['customerWebhookUrl'] = this.customerWebhookUrl;
    }
    if (typeof this.sendCancelationNotifications !== 'undefined') {
      toReturn['sendCancelationNotifications'] = this.sendCancelationNotifications;
    }
    if (typeof this.cancellationWebhookUrl !== 'undefined') {
      toReturn['cancellationWebhookUrl'] = this.cancellationWebhookUrl;
    }
    if (typeof this.serviceChangeWebhookUrl !== 'undefined') {
      toReturn['serviceChangeWebhookUrl'] = this.serviceChangeWebhookUrl;
    }
    if (typeof this.appLevelHasAdminDashboard !== 'undefined') {
      toReturn['appLevelHasAdminDashboard'] = this.appLevelHasAdminDashboard;
    }
    return toReturn;
  }
}
class UpdateAppMarketingInformationRequest {
  static fromProto(proto) {
    let m = new UpdateAppMarketingInformationRequest();
    m = Object.assign(m, proto);
    if (proto.marketingInfo) {
      m.marketingInfo = MarketingInformation.fromProto(proto.marketingInfo);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.marketingInfo !== 'undefined' && this.marketingInfo !== null) {
      toReturn['marketingInfo'] = 'toApiJson' in this.marketingInfo ? this.marketingInfo.toApiJson() : this.marketingInfo;
    }
    if (typeof this.usesMarketingInformation !== 'undefined') {
      toReturn['usesMarketingInformation'] = this.usesMarketingInformation;
    }
    return toReturn;
  }
}
class UpdateAppOrderFormRequest {
  static fromProto(proto) {
    let m = new UpdateAppOrderFormRequest();
    m = Object.assign(m, proto);
    if (proto.orderForm) {
      m.orderForm = OrderForm.fromProto(proto.orderForm);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.usesOrderForm !== 'undefined') {
      toReturn['usesOrderForm'] = this.usesOrderForm;
    }
    if (typeof this.orderForm !== 'undefined' && this.orderForm !== null) {
      toReturn['orderForm'] = 'toApiJson' in this.orderForm ? this.orderForm.toApiJson() : this.orderForm;
    }
    if (typeof this.usesActivationSpecificEntryUrl !== 'undefined') {
      toReturn['usesActivationSpecificEntryUrl'] = this.usesActivationSpecificEntryUrl;
    }
    if (typeof this.applicationUrl !== 'undefined') {
      toReturn['applicationUrl'] = this.applicationUrl;
    }
    return toReturn;
  }
}
class UpdateAppSSOIntegrationRequest {
  static fromProto(proto) {
    let m = new UpdateAppSSOIntegrationRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.entryUrl !== 'undefined') {
      toReturn['entryUrl'] = this.entryUrl;
    }
    if (typeof this.sessionUrl !== 'undefined') {
      toReturn['sessionUrl'] = this.sessionUrl;
    }
    if (typeof this.logoutUrl !== 'undefined') {
      toReturn['logoutUrl'] = this.logoutUrl;
    }
    if (typeof this.usesSsoIntegration !== 'undefined') {
      toReturn['usesSsoIntegration'] = this.usesSsoIntegration;
    }
    return toReturn;
  }
}
class UpdateAppTrialConfigurationRequest {
  static fromProto(proto) {
    let m = new UpdateAppTrialConfigurationRequest();
    m = Object.assign(m, proto);
    if (proto.endOfTrialAction) {
      m.endOfTrialAction = enumStringToValue$2(EndOfTrialActions, proto.endOfTrialAction);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.trialsEnabled !== 'undefined') {
      toReturn['trialsEnabled'] = this.trialsEnabled;
    }
    if (typeof this.duration !== 'undefined') {
      toReturn['duration'] = this.duration;
    }
    if (typeof this.endOfTrialAction !== 'undefined') {
      toReturn['endOfTrialAction'] = this.endOfTrialAction;
    }
    return toReturn;
  }
}
class UpdateVendorRequest {
  static fromProto(proto) {
    let m = new UpdateVendorRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.reportingCode !== 'undefined') {
      toReturn['reportingCode'] = this.reportingCode;
    }
    return toReturn;
  }
}
class UpdateVendorResponse {
  static fromProto(proto) {
    let m = new UpdateVendorResponse();
    m = Object.assign(m, proto);
    if (proto.vendor) {
      m.vendor = AppVendor.fromProto(proto.vendor);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.vendor !== 'undefined' && this.vendor !== null) {
      toReturn['vendor'] = 'toApiJson' in this.vendor ? this.vendor.toApiJson() : this.vendor;
    }
    return toReturn;
  }
}
function enumStringToValue$1(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class AppEditionsMarketing {
  static fromProto(proto) {
    let m = new AppEditionsMarketing();
    m = Object.assign(m, proto);
    if (proto.resellerMarketing) {
      m.resellerMarketing = EditionMarketingInformation.fromProto(proto.resellerMarketing);
    }
    if (proto.endUserMarketing) {
      m.endUserMarketing = EditionMarketingInformation.fromProto(proto.endUserMarketing);
    }
    if (proto.releaseType) {
      m.releaseType = enumStringToValue$1(Release, proto.releaseType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.editionId !== 'undefined') {
      toReturn['editionId'] = this.editionId;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.billingId !== 'undefined') {
      toReturn['billingId'] = this.billingId;
    }
    if (typeof this.usesResellerMarketing !== 'undefined') {
      toReturn['usesResellerMarketing'] = this.usesResellerMarketing;
    }
    if (typeof this.resellerMarketing !== 'undefined' && this.resellerMarketing !== null) {
      toReturn['resellerMarketing'] = 'toApiJson' in this.resellerMarketing ? this.resellerMarketing.toApiJson() : this.resellerMarketing;
    }
    if (typeof this.endUserMarketing !== 'undefined' && this.endUserMarketing !== null) {
      toReturn['endUserMarketing'] = 'toApiJson' in this.endUserMarketing ? this.endUserMarketing.toApiJson() : this.endUserMarketing;
    }
    if (typeof this.releaseType !== 'undefined') {
      toReturn['releaseType'] = this.releaseType;
    }
    return toReturn;
  }
}
class Edition {
  static fromProto(proto) {
    let m = new Edition();
    m = Object.assign(m, proto);
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.pricing) {
      m.pricing = EditionPricing.fromProto(proto.pricing);
    }
    if (proto.release) {
      m.release = enumStringToValue$1(Release, proto.release);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.editionId !== 'undefined') {
      toReturn['editionId'] = this.editionId;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.billingId !== 'undefined') {
      toReturn['billingId'] = this.billingId;
    }
    if (typeof this.pricing !== 'undefined' && this.pricing !== null) {
      toReturn['pricing'] = 'toApiJson' in this.pricing ? this.pricing.toApiJson() : this.pricing;
    }
    if (typeof this.currency !== 'undefined') {
      toReturn['currency'] = this.currency;
    }
    if (typeof this.billingFrequency !== 'undefined') {
      toReturn['billingFrequency'] = this.billingFrequency;
    }
    if (typeof this.release !== 'undefined') {
      toReturn['release'] = this.release;
    }
    return toReturn;
  }
}
class EditionMarketingInformation {
  static fromProto(proto) {
    let m = new EditionMarketingInformation();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.keySellingPoints !== 'undefined') {
      toReturn['keySellingPoints'] = this.keySellingPoints;
    }
    return toReturn;
  }
}
class EditionPricing {
  static fromProto(proto) {
    let m = new EditionPricing();
    m = Object.assign(m, proto);
    if (proto.wholesalePrice) {
      m.wholesalePrice = parseInt(proto.wholesalePrice, 10);
    }
    if (proto.suggestedRetailPrice) {
      m.suggestedRetailPrice = parseInt(proto.suggestedRetailPrice, 10);
    }
    if (proto.billingFrequency) {
      m.billingFrequency = enumStringToValue$1(EditionBillingFrequency, proto.billingFrequency);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.wholesalePrice !== 'undefined') {
      toReturn['wholesalePrice'] = this.wholesalePrice;
    }
    if (typeof this.suggestedRetailPrice !== 'undefined') {
      toReturn['suggestedRetailPrice'] = this.suggestedRetailPrice;
    }
    if (typeof this.billingFrequency !== 'undefined') {
      toReturn['billingFrequency'] = this.billingFrequency;
    }
    return toReturn;
  }
}
function enumStringToValue(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class ListByMultiAppResponseAppEditions {
  static fromProto(proto) {
    let m = new ListByMultiAppResponseAppEditions();
    m = Object.assign(m, proto);
    if (proto.editions) {
      m.editions = proto.editions.map(Edition.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.editions !== 'undefined' && this.editions !== null) {
      toReturn['editions'] = 'toApiJson' in this.editions ? this.editions.toApiJson() : this.editions;
    }
    return toReturn;
  }
}
class CreateEditionRequest {
  static fromProto(proto) {
    let m = new CreateEditionRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    return toReturn;
  }
}
class CreateEditionResponse {
  static fromProto(proto) {
    let m = new CreateEditionResponse();
    m = Object.assign(m, proto);
    if (proto.edition) {
      m.edition = Edition.fromProto(proto.edition);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.edition !== 'undefined' && this.edition !== null) {
      toReturn['edition'] = 'toApiJson' in this.edition ? this.edition.toApiJson() : this.edition;
    }
    return toReturn;
  }
}
class DeleteEditionRequest {
  static fromProto(proto) {
    let m = new DeleteEditionRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.editionId !== 'undefined') {
      toReturn['editionId'] = this.editionId;
    }
    return toReturn;
  }
}
class UpdateMultiEditionRequestEditionData {
  static fromProto(proto) {
    let m = new UpdateMultiEditionRequestEditionData();
    m = Object.assign(m, proto);
    if (proto.pricing) {
      m.pricing = EditionPricing.fromProto(proto.pricing);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.editionId !== 'undefined') {
      toReturn['editionId'] = this.editionId;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.pricing !== 'undefined' && this.pricing !== null) {
      toReturn['pricing'] = 'toApiJson' in this.pricing ? this.pricing.toApiJson() : this.pricing;
    }
    return toReturn;
  }
}
class GetBillingIDRequest {
  static fromProto(proto) {
    let m = new GetBillingIDRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.editionId !== 'undefined') {
      toReturn['editionId'] = this.editionId;
    }
    return toReturn;
  }
}
class GetBillingIDResponse {
  static fromProto(proto) {
    let m = new GetBillingIDResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.editionId !== 'undefined') {
      toReturn['editionId'] = this.editionId;
    }
    if (typeof this.billingId !== 'undefined') {
      toReturn['billingId'] = this.billingId;
    }
    return toReturn;
  }
}
class GetEditionRequest {
  static fromProto(proto) {
    let m = new GetEditionRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.editionId !== 'undefined') {
      toReturn['editionId'] = this.editionId;
    }
    return toReturn;
  }
}
class GetEditionResponse {
  static fromProto(proto) {
    let m = new GetEditionResponse();
    m = Object.assign(m, proto);
    if (proto.edition) {
      m.edition = Edition.fromProto(proto.edition);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.edition !== 'undefined' && this.edition !== null) {
      toReturn['edition'] = 'toApiJson' in this.edition ? this.edition.toApiJson() : this.edition;
    }
    return toReturn;
  }
}
class GetMultiDraftEditionRequest {
  static fromProto(proto) {
    let m = new GetMultiDraftEditionRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.editionIds !== 'undefined') {
      toReturn['editionIds'] = this.editionIds;
    }
    return toReturn;
  }
}
class GetMultiDraftEditionResponse {
  static fromProto(proto) {
    let m = new GetMultiDraftEditionResponse();
    m = Object.assign(m, proto);
    if (proto.editions) {
      m.editions = proto.editions.map(Edition.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.editions !== 'undefined' && this.editions !== null) {
      toReturn['editions'] = 'toApiJson' in this.editions ? this.editions.toApiJson() : this.editions;
    }
    return toReturn;
  }
}
class GetMultiEditionForMultiAppRequest {
  static fromProto(proto) {
    let m = new GetMultiEditionForMultiAppRequest();
    m = Object.assign(m, proto);
    if (proto.appEditionIdPairs) {
      m.appEditionIdPairs = proto.appEditionIdPairs.map(GetEditionRequest.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appEditionIdPairs !== 'undefined' && this.appEditionIdPairs !== null) {
      toReturn['appEditionIdPairs'] = 'toApiJson' in this.appEditionIdPairs ? this.appEditionIdPairs.toApiJson() : this.appEditionIdPairs;
    }
    return toReturn;
  }
}
class GetMultiEditionRequest {
  static fromProto(proto) {
    let m = new GetMultiEditionRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.editionIds !== 'undefined') {
      toReturn['editionIds'] = this.editionIds;
    }
    return toReturn;
  }
}
class GetMultiEditionResponse {
  static fromProto(proto) {
    let m = new GetMultiEditionResponse();
    m = Object.assign(m, proto);
    if (proto.editions) {
      m.editions = proto.editions.map(Edition.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.editions !== 'undefined' && this.editions !== null) {
      toReturn['editions'] = 'toApiJson' in this.editions ? this.editions.toApiJson() : this.editions;
    }
    return toReturn;
  }
}
class ListByMultiAppRequest {
  static fromProto(proto) {
    let m = new ListByMultiAppRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appIds !== 'undefined') {
      toReturn['appIds'] = this.appIds;
    }
    return toReturn;
  }
}
class ListByMultiAppResponse {
  static fromProto(proto) {
    let m = new ListByMultiAppResponse();
    m = Object.assign(m, proto);
    if (proto.appEditions) {
      m.appEditions = proto.appEditions.map(ListByMultiAppResponseAppEditions.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appEditions !== 'undefined' && this.appEditions !== null) {
      toReturn['appEditions'] = 'toApiJson' in this.appEditions ? this.appEditions.toApiJson() : this.appEditions;
    }
    return toReturn;
  }
}
class ListDraftEditionsForAppRequest {
  static fromProto(proto) {
    let m = new ListDraftEditionsForAppRequest();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    return toReturn;
  }
}
class ListDraftEditionsForAppResponse {
  static fromProto(proto) {
    let m = new ListDraftEditionsForAppResponse();
    m = Object.assign(m, proto);
    if (proto.editions) {
      m.editions = proto.editions.map(Edition.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.editions !== 'undefined' && this.editions !== null) {
      toReturn['editions'] = 'toApiJson' in this.editions ? this.editions.toApiJson() : this.editions;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    return toReturn;
  }
}
class ListEditionsForAppRequest {
  static fromProto(proto) {
    let m = new ListEditionsForAppRequest();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    return toReturn;
  }
}
class ListEditionsForAppResponse {
  static fromProto(proto) {
    let m = new ListEditionsForAppResponse();
    m = Object.assign(m, proto);
    if (proto.editions) {
      m.editions = proto.editions.map(Edition.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.editions !== 'undefined' && this.editions !== null) {
      toReturn['editions'] = 'toApiJson' in this.editions ? this.editions.toApiJson() : this.editions;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    return toReturn;
  }
}
class ListEditionsMarketingForAppRequest {
  static fromProto(proto) {
    let m = new ListEditionsMarketingForAppRequest();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    if (proto.releaseType) {
      m.releaseType = enumStringToValue(Release, proto.releaseType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    if (typeof this.releaseType !== 'undefined') {
      toReturn['releaseType'] = this.releaseType;
    }
    return toReturn;
  }
}
class ListEditionsMarketingForAppResponse {
  static fromProto(proto) {
    let m = new ListEditionsMarketingForAppResponse();
    m = Object.assign(m, proto);
    if (proto.appEditionsMarketing) {
      m.appEditionsMarketing = proto.appEditionsMarketing.map(AppEditionsMarketing.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appEditionsMarketing !== 'undefined' && this.appEditionsMarketing !== null) {
      toReturn['appEditionsMarketing'] = 'toApiJson' in this.appEditionsMarketing ? this.appEditionsMarketing.toApiJson() : this.appEditionsMarketing;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    return toReturn;
  }
}
class UpdateEditionRequest {
  static fromProto(proto) {
    let m = new UpdateEditionRequest();
    m = Object.assign(m, proto);
    if (proto.pricing) {
      m.pricing = EditionPricing.fromProto(proto.pricing);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.editionId !== 'undefined') {
      toReturn['editionId'] = this.editionId;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.pricing !== 'undefined' && this.pricing !== null) {
      toReturn['pricing'] = 'toApiJson' in this.pricing ? this.pricing.toApiJson() : this.pricing;
    }
    return toReturn;
  }
}
class UpdateMultiEditionRequest {
  static fromProto(proto) {
    let m = new UpdateMultiEditionRequest();
    m = Object.assign(m, proto);
    if (proto.editions) {
      m.editions = proto.editions.map(UpdateMultiEditionRequestEditionData.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.editions !== 'undefined' && this.editions !== null) {
      toReturn['editions'] = 'toApiJson' in this.editions ? this.editions.toApiJson() : this.editions;
    }
    return toReturn;
  }
}
class UpsertEditionsMarketingRequest {
  static fromProto(proto) {
    let m = new UpsertEditionsMarketingRequest();
    m = Object.assign(m, proto);
    if (proto.resellerMarketing) {
      m.resellerMarketing = EditionMarketingInformation.fromProto(proto.resellerMarketing);
    }
    if (proto.endUserMarketing) {
      m.endUserMarketing = EditionMarketingInformation.fromProto(proto.endUserMarketing);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.editionId !== 'undefined') {
      toReturn['editionId'] = this.editionId;
    }
    if (typeof this.usesResellerMarketing !== 'undefined') {
      toReturn['usesResellerMarketing'] = this.usesResellerMarketing;
    }
    if (typeof this.resellerMarketing !== 'undefined' && this.resellerMarketing !== null) {
      toReturn['resellerMarketing'] = 'toApiJson' in this.resellerMarketing ? this.resellerMarketing.toApiJson() : this.resellerMarketing;
    }
    if (typeof this.endUserMarketing !== 'undefined' && this.endUserMarketing !== null) {
      toReturn['endUserMarketing'] = 'toApiJson' in this.endUserMarketing ? this.endUserMarketing.toApiJson() : this.endUserMarketing;
    }
    return toReturn;
  }
}

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Objects Index.
// *********************************

const environment = (window ? window['environment'] : 'prod') ?? 'prod';
const hostMap = {
  'local': '',
  'test': '',
  'demo': 'marketplace-apps-api-demo.apigateway.co',
  'prod': 'marketplace-apps-api-prod.apigateway.co',
  'production': 'marketplace-apps-api-prod.apigateway.co'
};
let HostService = /*#__PURE__*/(() => {
  class HostService {
    get host() {
      return hostMap[environment.toLowerCase()];
    }
    get hostWithScheme() {
      return 'https://' + this.host;
    }
  }
  HostService.ɵfac = function HostService_Factory(t) {
    return new (t || HostService)();
  };
  HostService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: HostService,
    factory: HostService.ɵfac,
    providedIn: 'root'
  });
  return HostService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let EditionsApiService = /*#__PURE__*/(() => {
  class EditionsApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    create(r) {
      const request = r.toApiJson ? r : new CreateEditionRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v1.Editions/Create", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateEditionResponse.fromProto(resp)));
    }
    update(r) {
      const request = r.toApiJson ? r : new UpdateEditionRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v1.Editions/Update", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    updateMulti(r) {
      const request = r.toApiJson ? r : new UpdateMultiEditionRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v1.Editions/UpdateMulti", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    delete(r) {
      const request = r.toApiJson ? r : new DeleteEditionRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v1.Editions/Delete", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    get(r) {
      const request = r.toApiJson ? r : new GetEditionRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v1.Editions/Get", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetEditionResponse.fromProto(resp)));
    }
    getMulti(r) {
      const request = r.toApiJson ? r : new GetMultiEditionRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v1.Editions/GetMulti", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiEditionResponse.fromProto(resp)));
    }
    getMultiDraft(r) {
      const request = r.toApiJson ? r : new GetMultiDraftEditionRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v1.Editions/GetMultiDraft", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiDraftEditionResponse.fromProto(resp)));
    }
    getBillingId(r) {
      const request = r.toApiJson ? r : new GetBillingIDRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v1.Editions/GetBillingID", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetBillingIDResponse.fromProto(resp)));
    }
    listEditionsForApp(r) {
      const request = r.toApiJson ? r : new ListEditionsForAppRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v1.Editions/ListEditionsForApp", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListEditionsForAppResponse.fromProto(resp)));
    }
    listDraftEditionsForApp(r) {
      const request = r.toApiJson ? r : new ListDraftEditionsForAppRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v1.Editions/ListDraftEditionsForApp", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListDraftEditionsForAppResponse.fromProto(resp)));
    }
    getMultiEditionForMultiApp(r) {
      const request = r.toApiJson ? r : new GetMultiEditionForMultiAppRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v1.Editions/GetMultiEditionForMultiApp", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiEditionResponse.fromProto(resp)));
    }
    listByMultiApp(r) {
      const request = r.toApiJson ? r : new ListByMultiAppRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v1.Editions/ListByMultiApp", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListByMultiAppResponse.fromProto(resp)));
    }
    upsertEditionsMarketing(r) {
      const request = r.toApiJson ? r : new UpsertEditionsMarketingRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v1.Editions/UpsertEditionsMarketing", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    listEditionsMarketingForApp(r) {
      const request = r.toApiJson ? r : new ListEditionsMarketingForAppRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v1.Editions/ListEditionsMarketingForApp", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListEditionsMarketingForAppResponse.fromProto(resp)));
    }
  }
  EditionsApiService.ɵfac = function EditionsApiService_Factory(t) {
    return new (t || EditionsApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  EditionsApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: EditionsApiService,
    factory: EditionsApiService.ɵfac,
    providedIn: 'root'
  });
  return EditionsApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let MarketplaceAppsApiService = /*#__PURE__*/(() => {
  class MarketplaceAppsApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    listAddons(r) {
      const request = r.toApiJson ? r : new ListAddonsRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v1.MarketplaceApps/ListAddons", request.toApiJson(), this.apiOptions()).pipe(map(resp => AddonsListResponse.fromProto(resp)));
    }
    getAddon(r) {
      const request = r.toApiJson ? r : new GetAddonRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v1.MarketplaceApps/GetAddon", request.toApiJson(), this.apiOptions()).pipe(map(resp => AddonResponse.fromProto(resp)));
    }
    getPublicKeys(r) {
      const request = r.toApiJson ? r : new GetPublicKeysRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v1.MarketplaceApps/GetPublicKeys", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetPublicKeysResponse.fromProto(resp)));
    }
    getSsoUrls(r) {
      const request = r.toApiJson ? r : new GetSSOUrlsRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v1.MarketplaceApps/GetSSOUrls", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetSSOUrlsResponse.fromProto(resp)));
    }
    getApp(r) {
      const request = r.toApiJson ? r : new GetAppRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v1.MarketplaceApps/GetApp", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetAppResponse.fromProto(resp)));
    }
    getMultiApp(r) {
      const request = r.toApiJson ? r : new GetMultiAppRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v1.MarketplaceApps/GetMultiApp", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiAppResponse.fromProto(resp)));
    }
    listApps(r) {
      const request = r.toApiJson ? r : new ListAppsRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v1.MarketplaceApps/ListApps", request.toApiJson(), this.apiOptions()).pipe(map(resp => PagedAppResponse.fromProto(resp)));
    }
    listAppsForVendorIDs(r) {
      const request = r.toApiJson ? r : new ListAppsForVendorIDsRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v1.MarketplaceApps/ListAppsForVendorIDs", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListAppsForVendorIDsResponse.fromProto(resp)));
    }
    getAppDraft(r) {
      const request = r.toApiJson ? r : new GetAppRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v1.MarketplaceApps/GetAppDraft", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetAppResponse.fromProto(resp)));
    }
    getMultiAppDraft(r) {
      const request = r.toApiJson ? r : new GetMultiAppRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v1.MarketplaceApps/GetMultiAppDraft", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiAppResponse.fromProto(resp)));
    }
    approveAddon(r) {
      const request = r.toApiJson ? r : new ApproveAddonRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v1.MarketplaceApps/ApproveAddon", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    unapproveAddon(r) {
      const request = r.toApiJson ? r : new UnapproveAddonRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v1.MarketplaceApps/UnapproveAddon", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    listApprovedAddons(r) {
      const request = r.toApiJson ? r : new ListApprovedAddonsRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v1.MarketplaceApps/ListApprovedAddons", request.toApiJson(), this.apiOptions()).pipe(map(resp => AddonsListResponse.fromProto(resp)));
    }
    getMultiOrderForms(r) {
      const request = r.toApiJson ? r : new GetMultiOrderFormsRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v1.MarketplaceApps/GetMultiOrderForms", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiOrderFormsResponse.fromProto(resp)));
    }
    createApp(r) {
      const request = r.toApiJson ? r : new CreateAppRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v1.MarketplaceApps/CreateApp", request.toApiJson(), this.apiOptions()).pipe(map(resp => AppResponse.fromProto(resp)));
    }
    deleteApp(r) {
      const request = r.toApiJson ? r : new DeleteAppRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v1.MarketplaceApps/DeleteApp", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    restoreApp(r) {
      const request = r.toApiJson ? r : new RestoreAppRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v1.MarketplaceApps/RestoreApp", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    duplicateApp(r) {
      const request = r.toApiJson ? r : new DuplicateAppRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v1.MarketplaceApps/DuplicateApp", request.toApiJson(), this.apiOptions()).pipe(map(resp => DuplicateAppResponse.fromProto(resp)));
    }
    updateAppGeneralSettings(r) {
      const request = r.toApiJson ? r : new UpdateAppGeneralInformationRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v1.MarketplaceApps/UpdateAppGeneralSettings", request.toApiJson(), this.apiOptions()).pipe(map(resp => AppResponse.fromProto(resp)));
    }
    updateAppIntegration(r) {
      const request = r.toApiJson ? r : new UpdateAppIntegrationRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v1.MarketplaceApps/UpdateAppIntegration", request.toApiJson(), this.apiOptions()).pipe(map(resp => AppResponse.fromProto(resp)));
    }
    updateAppOrderForm(r) {
      const request = r.toApiJson ? r : new UpdateAppOrderFormRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v1.MarketplaceApps/UpdateAppOrderForm", request.toApiJson(), this.apiOptions()).pipe(map(resp => AppResponse.fromProto(resp)));
    }
    updateAppEndUserMarketingInformation(r) {
      const request = r.toApiJson ? r : new UpdateAppMarketingInformationRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v1.MarketplaceApps/UpdateAppEndUserMarketingInformation", request.toApiJson(), this.apiOptions()).pipe(map(resp => AppResponse.fromProto(resp)));
    }
    updateAppResellerMarketingInformation(r) {
      const request = r.toApiJson ? r : new UpdateAppMarketingInformationRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v1.MarketplaceApps/UpdateAppResellerMarketingInformation", request.toApiJson(), this.apiOptions()).pipe(map(resp => AppResponse.fromProto(resp)));
    }
    updateAppSsoIntegration(r) {
      const request = r.toApiJson ? r : new UpdateAppSSOIntegrationRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v1.MarketplaceApps/UpdateAppSSOIntegration", request.toApiJson(), this.apiOptions()).pipe(map(resp => AppResponse.fromProto(resp)));
    }
    updateAppFulfillmentIntegration(r) {
      const request = r.toApiJson ? r : new UpdateAppFulfillmentIntegrationRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v1.MarketplaceApps/UpdateAppFulfillmentIntegration", request.toApiJson(), this.apiOptions()).pipe(map(resp => AppResponse.fromProto(resp)));
    }
    updateAppTrialConfiguration(r) {
      const request = r.toApiJson ? r : new UpdateAppTrialConfigurationRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v1.MarketplaceApps/UpdateAppTrialConfiguration", request.toApiJson(), this.apiOptions()).pipe(map(resp => AppResponse.fromProto(resp)));
    }
    approveApp(r) {
      const request = r.toApiJson ? r : new ApproveAppRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v1.MarketplaceApps/ApproveApp", request.toApiJson(), this.apiOptions()).pipe(map(resp => AppResponse.fromProto(resp)));
    }
    unapproveApp(r) {
      const request = r.toApiJson ? r : new UnapproveAppRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v1.MarketplaceApps/UnapproveApp", request.toApiJson(), this.apiOptions()).pipe(map(resp => AppResponse.fromProto(resp)));
    }
    updateAppApprovalAndBillingSettings(r) {
      const request = r.toApiJson ? r : new UpdateAppApprovalAndBillingSettingsRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v1.MarketplaceApps/UpdateAppApprovalAndBillingSettings", request.toApiJson(), this.apiOptions()).pipe(map(resp => AppResponse.fromProto(resp)));
    }
    publishApp(r) {
      const request = r.toApiJson ? r : new PublishAppRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v1.MarketplaceApps/PublishApp", request.toApiJson(), this.apiOptions()).pipe(map(resp => AppResponse.fromProto(resp)));
    }
    getAppsWithUnpublishedChanges(r) {
      const request = r.toApiJson ? r : new GetAppsWithUnpublishedChangesRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v1.MarketplaceApps/GetAppsWithUnpublishedChanges", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetAppsWithUnpublishedChangesResponse.fromProto(resp)));
    }
    canActivate(r) {
      const request = r.toApiJson ? r : new CanActivateRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v1.MarketplaceApps/CanActivate", request.toApiJson(), this.apiOptions()).pipe(map(resp => CanActivateResponse.fromProto(resp)));
    }
    getAppsToDeactivateUponDeactivation(r) {
      const request = r.toApiJson ? r : new GetAppsToDeactivateUponDeactivationRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v1.MarketplaceApps/GetAppsToDeactivateUponDeactivation", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetAppsToDeactivateUponDeactivationResponse.fromProto(resp)));
    }
    getAppIdFromSku(r) {
      const request = r.toApiJson ? r : new GetAppIDFromSkuRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v1.MarketplaceApps/GetAppIDFromSku", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetAppIDFromSkuResponse.fromProto(resp)));
    }
    getMultiProductCost(r) {
      const request = r.toApiJson ? r : new GetMultiProductCostRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v1.MarketplaceApps/GetMultiProductCost", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiProductCostResponse.fromProto(resp)));
    }
    updateCategories(r) {
      const request = r.toApiJson ? r : new UpdateAppCategoriesRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v1.MarketplaceApps/UpdateCategories", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    suspendApp(r) {
      const request = r.toApiJson ? r : new SuspendAppRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v1.MarketplaceApps/SuspendApp", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    unsuspendApp(r) {
      const request = r.toApiJson ? r : new UnsuspendAppRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v1.MarketplaceApps/UnsuspendApp", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    requestAppReview(r) {
      const request = r.toApiJson ? r : new RequestAppReviewRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v1.MarketplaceApps/RequestAppReview", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    listRequiredAppSummaries(r) {
      const request = r.toApiJson ? r : new ListRequiredAppSummariesRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v1.MarketplaceApps/ListRequiredAppSummaries", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListRequiredAppSummariesResponse.fromProto(resp)));
    }
  }
  MarketplaceAppsApiService.ɵfac = function MarketplaceAppsApiService_Factory(t) {
    return new (t || MarketplaceAppsApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  MarketplaceAppsApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: MarketplaceAppsApiService,
    factory: MarketplaceAppsApiService.ɵfac,
    providedIn: 'root'
  });
  return MarketplaceAppsApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let VendorApiService = /*#__PURE__*/(() => {
  class VendorApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    create(r) {
      const request = r.toApiJson ? r : new CreateVendorRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v1.Vendor/Create", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateVendorResponse.fromProto(resp)));
    }
    list(r) {
      const request = r.toApiJson ? r : new ListVendorRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v1.Vendor/List", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListVendorResponse.fromProto(resp)));
    }
    getMulti(r) {
      const request = r.toApiJson ? r : new GetMultiVendorRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v1.Vendor/GetMulti", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiVendorResponse.fromProto(resp)));
    }
    addAppId(r) {
      const request = r.toApiJson ? r : new AddAppIDRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v1.Vendor/AddAppID", request.toApiJson(), this.apiOptions()).pipe(map(resp => AddAppIDResponse.fromProto(resp)));
    }
    removeAppId(r) {
      const request = r.toApiJson ? r : new RemoveAppIDRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v1.Vendor/RemoveAppID", request.toApiJson(), this.apiOptions()).pipe(map(resp => RemoveAppIDResponse.fromProto(resp)));
    }
    update(r) {
      const request = r.toApiJson ? r : new UpdateVendorRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v1.Vendor/Update", request.toApiJson(), this.apiOptions()).pipe(map(resp => UpdateVendorResponse.fromProto(resp)));
    }
    getOwnedAppIDsByPartnerId(r) {
      const request = r.toApiJson ? r : new GetOwnedAppIDsByPartnerIDRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v1.Vendor/GetOwnedAppIDsByPartnerID", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetOwnedAppIDsByPartnerIDResponse.fromProto(resp)));
    }
    getByPartnerId(r) {
      const request = r.toApiJson ? r : new GetByPartnerIDRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v1.Vendor/GetByPartnerID", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetByPartnerIDResponse.fromProto(resp)));
    }
    isVendorDistributed(r) {
      const request = r.toApiJson ? r : new IsVendorDistributedByPartnerIDRequest(r);
      return this.http.post(this._host + "/marketplaceapps.v1.Vendor/IsVendorDistributed", request.toApiJson(), this.apiOptions()).pipe(map(resp => IsVendorDistributedByPartnerIDResponse.fromProto(resp)));
    }
  }
  VendorApiService.ɵfac = function VendorApiService_Factory(t) {
    return new (t || VendorApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  VendorApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: VendorApiService,
    factory: VendorApiService.ɵfac,
    providedIn: 'root'
  });
  return VendorApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Index.
// *********************************

/**
 * Generated bundle index. Do not edit.
 */

export { Access, ActiveAppEditionIdentifier, AddAppIDRequest, AddAppIDResponse, Addon, AddonResponse, AddonsListResponse, AppEditionsMarketing, AppRequirement, AppResponse, AppType, AppVendor, ApprovalProcess, ApproveAddonRequest, ApproveAppRequest, BillingProcess, CanActivateRequest, CanActivateResponse, CanActivateResponseInvalidResponse, CanActivateResponseSuccessResponse, Commitment, Contact, Cost, CreateAppRequest, CreateEditionRequest, CreateEditionResponse, CreateVendorRequest, CreateVendorResponse, DeleteAppRequest, DeleteEditionRequest, DeliveryMethod, DistributionSetting, DuplicateAppRequest, DuplicateAppResponse, Edition, EditionBillingFrequency, EditionIdentifier, EditionMarketingInformation, EditionPricing, EditionsApiService, EndOfTrialActions, Fee, FeeAmountType, FeeType, FieldMask, FrequentlyAskedQuestions, GetAddonRequest, GetAppIDFromSkuRequest, GetAppIDFromSkuResponse, GetAppRequest, GetAppResponse, GetAppsToDeactivateUponDeactivationRequest, GetAppsToDeactivateUponDeactivationResponse, GetAppsWithUnpublishedChangesRequest, GetAppsWithUnpublishedChangesResponse, GetBillingIDRequest, GetBillingIDResponse, GetByPartnerIDRequest, GetByPartnerIDResponse, GetEditionRequest, GetEditionResponse, GetMultiAppRequest, GetMultiAppResponse, GetMultiDraftEditionRequest, GetMultiDraftEditionResponse, GetMultiEditionForMultiAppRequest, GetMultiEditionRequest, GetMultiEditionResponse, GetMultiOrderFormsRequest, GetMultiOrderFormsResponse, GetMultiOrderFormsResponseOrderFormContainer, GetMultiProductCostRequest, GetMultiProductCostResponse, GetMultiProductCostResponseProductCostEntry, GetMultiVendorRequest, GetMultiVendorResponse, GetOwnedAppIDsByPartnerIDRequest, GetOwnedAppIDsByPartnerIDResponse, GetPublicKeysRequest, GetPublicKeysResponse, GetSSOUrlsRequest, GetSSOUrlsResponse, HostService, IdentifiedPublicKey, IncludedCommonFormFields, Integration, IsVendorDistributedByPartnerIDRequest, IsVendorDistributedByPartnerIDResponse, ListAddonsRequest, ListApprovedAddonsRequest, ListAppsForVendorIDsRequest, ListAppsForVendorIDsResponse, ListAppsRequest, ListAppsRequestListAppsFilter, ListByMultiAppRequest, ListByMultiAppResponse, ListByMultiAppResponseAppEditions, ListDraftEditionsForAppRequest, ListDraftEditionsForAppResponse, ListEditionsForAppRequest, ListEditionsForAppResponse, ListEditionsMarketingForAppRequest, ListEditionsMarketingForAppResponse, ListRequiredAppSummariesFilters, ListRequiredAppSummariesRequest, ListRequiredAppSummariesResponse, ListVendorRequest, ListVendorResponse, MarketingInformation, MarketplaceApp, MarketplaceAppLmi, MarketplaceAppLmiLmiCategories, MarketplaceAppProduct, MarketplaceAppProductProductCategories, MarketplaceAppsApiService, OrderForm, OrderFormField, OrderFormFieldOption, PagedAppResponse, PermissionLists, ProductCost, ProductCostEditionCostEntry, PublishAppRequest, Release, ReleaseType, RemoveAppIDRequest, RemoveAppIDResponse, RequestAppReviewRequest, RequiredAppSummary, RequiredBusinessData, RequiredFeatures, RestoreAppRequest, Restrictions, Rule, State, StateFilterOptions, SuspendAppRequest, TrialConfiguration, UnapproveAddonRequest, UnapproveAppRequest, UnsuspendAppRequest, UpdateAppApprovalAndBillingSettingsRequest, UpdateAppCategoriesRequest, UpdateAppFulfillmentIntegrationRequest, UpdateAppGeneralInformationRequest, UpdateAppIntegrationRequest, UpdateAppMarketingInformationRequest, UpdateAppOrderFormRequest, UpdateAppSSOIntegrationRequest, UpdateAppTrialConfigurationRequest, UpdateEditionRequest, UpdateMultiEditionRequest, UpdateMultiEditionRequestEditionData, UpdateVendorRequest, UpdateVendorResponse, UpsertEditionsMarketingRequest, VendorApiService };
